import _defineProperty from "/workdir/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _get from "/workdir/node_modules/@babel/runtime/helpers/esm/get";
import _regeneratorRuntime from "/workdir/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/workdir/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "/workdir/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/workdir/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/workdir/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workdir/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workdir/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _edOIDs;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/*!
 Copyright (c) Peculiar Ventures, LLC
*/
import * as core from 'webcrypto-core';
import { BufferSourceConverter as BufferSourceConverter$1 } from 'webcrypto-core';
export { CryptoKey } from 'webcrypto-core';
import * as crypto from 'crypto';
import crypto__default from 'crypto';
import * as process from 'process';
import { __decorate } from 'tslib';
import { JsonProp, JsonPropTypes, JsonSerializer, JsonParser } from '@peculiar/json-schema';
import { Convert, BufferSourceConverter } from 'pvtsutils';
import { AsnParser, AsnSerializer } from '@peculiar/asn1-schema';
var JsonBase64UrlConverter = {
  fromJSON: function fromJSON(value) {
    return Buffer.from(Convert.FromBase64Url(value));
  },
  toJSON: function toJSON(value) {
    return Convert.ToBase64Url(value);
  }
};

var CryptoKey = /*#__PURE__*/function (_core$CryptoKey) {
  _inherits(CryptoKey, _core$CryptoKey);

  var _super = _createSuper(CryptoKey);

  function CryptoKey() {
    var _this;

    _classCallCheck(this, CryptoKey);

    _this = _super.apply(this, arguments);
    _this.data = Buffer.alloc(0);
    _this.algorithm = {
      name: ""
    };
    _this.extractable = false;
    _this.type = "secret";
    _this.usages = [];
    _this.kty = "oct";
    _this.alg = "";
    return _this;
  }

  return CryptoKey;
}(core.CryptoKey);

__decorate([JsonProp({
  name: "ext",
  type: JsonPropTypes.Boolean,
  optional: true
})], CryptoKey.prototype, "extractable", void 0);

__decorate([JsonProp({
  name: "key_ops",
  type: JsonPropTypes.String,
  repeated: true,
  optional: true
})], CryptoKey.prototype, "usages", void 0);

__decorate([JsonProp({
  type: JsonPropTypes.String
})], CryptoKey.prototype, "kty", void 0);

__decorate([JsonProp({
  type: JsonPropTypes.String,
  optional: true
})], CryptoKey.prototype, "alg", void 0);

var SymmetricKey = /*#__PURE__*/function (_CryptoKey) {
  _inherits(SymmetricKey, _CryptoKey);

  var _super2 = _createSuper(SymmetricKey);

  function SymmetricKey() {
    var _this2;

    _classCallCheck(this, SymmetricKey);

    _this2 = _super2.apply(this, arguments);
    _this2.kty = "oct";
    _this2.type = "secret";
    return _this2;
  }

  return SymmetricKey;
}(CryptoKey);

var AsymmetricKey = /*#__PURE__*/function (_CryptoKey2) {
  _inherits(AsymmetricKey, _CryptoKey2);

  var _super3 = _createSuper(AsymmetricKey);

  function AsymmetricKey() {
    _classCallCheck(this, AsymmetricKey);

    return _super3.apply(this, arguments);
  }

  return AsymmetricKey;
}(CryptoKey);

var AesCryptoKey = /*#__PURE__*/function (_SymmetricKey) {
  _inherits(AesCryptoKey, _SymmetricKey);

  var _super4 = _createSuper(AesCryptoKey);

  function AesCryptoKey() {
    _classCallCheck(this, AesCryptoKey);

    return _super4.apply(this, arguments);
  }

  _createClass(AesCryptoKey, [{
    key: "alg",
    get: function get() {
      switch (this.algorithm.name.toUpperCase()) {
        case "AES-CBC":
          return "A".concat(this.algorithm.length, "CBC");

        case "AES-CTR":
          return "A".concat(this.algorithm.length, "CTR");

        case "AES-GCM":
          return "A".concat(this.algorithm.length, "GCM");

        case "AES-KW":
          return "A".concat(this.algorithm.length, "KW");

        case "AES-CMAC":
          return "A".concat(this.algorithm.length, "CMAC");

        case "AES-ECB":
          return "A".concat(this.algorithm.length, "ECB");

        default:
          throw new core.AlgorithmError("Unsupported algorithm name");
      }
    },
    set: function set(value) {}
  }]);

  return AesCryptoKey;
}(SymmetricKey);

__decorate([JsonProp({
  name: "k",
  converter: JsonBase64UrlConverter
})], AesCryptoKey.prototype, "data", void 0);

var AesCrypto = /*#__PURE__*/function () {
  function AesCrypto() {
    _classCallCheck(this, AesCrypto);
  }

  _createClass(AesCrypto, null, [{
    key: "generateKey",
    value: function () {
      var _generateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = new AesCryptoKey();
                key.algorithm = algorithm;
                key.extractable = extractable;
                key.usages = keyUsages;
                key.data = crypto__default.randomBytes(algorithm.length >> 3);
                return _context.abrupt("return", key);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function generateKey(_x, _x2, _x3) {
        return _generateKey.apply(this, arguments);
      }

      return generateKey;
    }()
  }, {
    key: "exportKey",
    value: function () {
      var _exportKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(format, key) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (key instanceof AesCryptoKey) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("key: Is not AesCryptoKey");

              case 2:
                _context2.t0 = format.toLowerCase();
                _context2.next = _context2.t0 === "jwk" ? 5 : _context2.t0 === "raw" ? 6 : 7;
                break;

              case 5:
                return _context2.abrupt("return", JsonSerializer.toJSON(key));

              case 6:
                return _context2.abrupt("return", new Uint8Array(key.data).buffer);

              case 7:
                throw new core.OperationError("format: Must be 'jwk' or 'raw'");

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function exportKey(_x4, _x5) {
        return _exportKey.apply(this, arguments);
      }

      return exportKey;
    }()
  }, {
    key: "importKey",
    value: function () {
      var _importKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = format.toLowerCase();
                _context3.next = _context3.t0 === "jwk" ? 3 : _context3.t0 === "raw" ? 5 : 8;
                break;

              case 3:
                key = JsonParser.fromJSON(keyData, {
                  targetSchema: AesCryptoKey
                });
                return _context3.abrupt("break", 9);

              case 5:
                key = new AesCryptoKey();
                key.data = Buffer.from(keyData);
                return _context3.abrupt("break", 9);

              case 8:
                throw new core.OperationError("format: Must be 'jwk' or 'raw'");

              case 9:
                key.algorithm = algorithm;
                key.algorithm.length = key.data.length << 3;
                key.extractable = extractable;
                key.usages = keyUsages;
                _context3.t1 = key.algorithm.length;
                _context3.next = _context3.t1 === 128 ? 16 : _context3.t1 === 192 ? 16 : _context3.t1 === 256 ? 16 : 17;
                break;

              case 16:
                return _context3.abrupt("break", 18);

              case 17:
                throw new core.OperationError("keyData: Is wrong key length");

              case 18:
                return _context3.abrupt("return", key);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function importKey(_x6, _x7, _x8, _x9, _x10) {
        return _importKey.apply(this, arguments);
      }

      return importKey;
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.t0 = algorithm.name.toUpperCase();
                _context4.next = _context4.t0 === "AES-CBC" ? 3 : _context4.t0 === "AES-CTR" ? 4 : _context4.t0 === "AES-GCM" ? 5 : _context4.t0 === "AES-KW" ? 6 : _context4.t0 === "AES-ECB" ? 7 : 8;
                break;

              case 3:
                return _context4.abrupt("return", this.encryptAesCBC(algorithm, key, Buffer.from(data)));

              case 4:
                return _context4.abrupt("return", this.encryptAesCTR(algorithm, key, Buffer.from(data)));

              case 5:
                return _context4.abrupt("return", this.encryptAesGCM(algorithm, key, Buffer.from(data)));

              case 6:
                return _context4.abrupt("return", this.encryptAesKW(algorithm, key, Buffer.from(data)));

              case 7:
                return _context4.abrupt("return", this.encryptAesECB(algorithm, key, Buffer.from(data)));

              case 8:
                throw new core.OperationError("algorithm: Is not recognized");

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function encrypt(_x11, _x12, _x13) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (key instanceof AesCryptoKey) {
                  _context5.next = 2;
                  break;
                }

                throw new Error("key: Is not AesCryptoKey");

              case 2:
                _context5.t0 = algorithm.name.toUpperCase();
                _context5.next = _context5.t0 === "AES-CBC" ? 5 : _context5.t0 === "AES-CTR" ? 6 : _context5.t0 === "AES-GCM" ? 7 : _context5.t0 === "AES-KW" ? 8 : _context5.t0 === "AES-ECB" ? 9 : 10;
                break;

              case 5:
                return _context5.abrupt("return", this.decryptAesCBC(algorithm, key, Buffer.from(data)));

              case 6:
                return _context5.abrupt("return", this.decryptAesCTR(algorithm, key, Buffer.from(data)));

              case 7:
                return _context5.abrupt("return", this.decryptAesGCM(algorithm, key, Buffer.from(data)));

              case 8:
                return _context5.abrupt("return", this.decryptAesKW(algorithm, key, Buffer.from(data)));

              case 9:
                return _context5.abrupt("return", this.decryptAesECB(algorithm, key, Buffer.from(data)));

              case 10:
                throw new core.OperationError("algorithm: Is not recognized");

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function decrypt(_x14, _x15, _x16) {
        return _decrypt.apply(this, arguments);
      }

      return decrypt;
    }()
  }, {
    key: "encryptAesCBC",
    value: function () {
      var _encryptAesCBC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(algorithm, key, data) {
        var cipher, enc, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                cipher = crypto__default.createCipheriv("aes-".concat(key.algorithm.length, "-cbc"), key.data, new Uint8Array(algorithm.iv));
                enc = cipher.update(data);
                enc = Buffer.concat([enc, cipher.final()]);
                res = new Uint8Array(enc).buffer;
                return _context6.abrupt("return", res);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function encryptAesCBC(_x17, _x18, _x19) {
        return _encryptAesCBC.apply(this, arguments);
      }

      return encryptAesCBC;
    }()
  }, {
    key: "decryptAesCBC",
    value: function () {
      var _decryptAesCBC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(algorithm, key, data) {
        var decipher, dec;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                decipher = crypto__default.createDecipheriv("aes-".concat(key.algorithm.length, "-cbc"), key.data, new Uint8Array(algorithm.iv));
                dec = decipher.update(data);
                dec = Buffer.concat([dec, decipher.final()]);
                return _context7.abrupt("return", new Uint8Array(dec).buffer);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function decryptAesCBC(_x20, _x21, _x22) {
        return _decryptAesCBC.apply(this, arguments);
      }

      return decryptAesCBC;
    }()
  }, {
    key: "encryptAesCTR",
    value: function () {
      var _encryptAesCTR = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(algorithm, key, data) {
        var cipher, enc, res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                cipher = crypto__default.createCipheriv("aes-".concat(key.algorithm.length, "-ctr"), key.data, Buffer.from(algorithm.counter));
                enc = cipher.update(data);
                enc = Buffer.concat([enc, cipher.final()]);
                res = new Uint8Array(enc).buffer;
                return _context8.abrupt("return", res);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function encryptAesCTR(_x23, _x24, _x25) {
        return _encryptAesCTR.apply(this, arguments);
      }

      return encryptAesCTR;
    }()
  }, {
    key: "decryptAesCTR",
    value: function () {
      var _decryptAesCTR = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(algorithm, key, data) {
        var decipher, dec;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                decipher = crypto__default.createDecipheriv("aes-".concat(key.algorithm.length, "-ctr"), key.data, new Uint8Array(algorithm.counter));
                dec = decipher.update(data);
                dec = Buffer.concat([dec, decipher.final()]);
                return _context9.abrupt("return", new Uint8Array(dec).buffer);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function decryptAesCTR(_x26, _x27, _x28) {
        return _decryptAesCTR.apply(this, arguments);
      }

      return decryptAesCTR;
    }()
  }, {
    key: "encryptAesGCM",
    value: function () {
      var _encryptAesGCM = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(algorithm, key, data) {
        var cipher, enc, res;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                cipher = crypto__default.createCipheriv("aes-".concat(key.algorithm.length, "-gcm"), key.data, Buffer.from(algorithm.iv), {
                  authTagLength: (algorithm.tagLength || 128) >> 3
                });

                if (algorithm.additionalData) {
                  cipher.setAAD(Buffer.from(algorithm.additionalData));
                }

                enc = cipher.update(data);
                enc = Buffer.concat([enc, cipher.final(), cipher.getAuthTag()]);
                res = new Uint8Array(enc).buffer;
                return _context10.abrupt("return", res);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function encryptAesGCM(_x29, _x30, _x31) {
        return _encryptAesGCM.apply(this, arguments);
      }

      return encryptAesGCM;
    }()
  }, {
    key: "decryptAesGCM",
    value: function () {
      var _decryptAesGCM = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(algorithm, key, data) {
        var decipher, tagLength, enc, tag, dec;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                decipher = crypto__default.createDecipheriv("aes-".concat(key.algorithm.length, "-gcm"), key.data, new Uint8Array(algorithm.iv));
                tagLength = (algorithm.tagLength || 128) >> 3;
                enc = data.slice(0, data.length - tagLength);
                tag = data.slice(data.length - tagLength);

                if (algorithm.additionalData) {
                  decipher.setAAD(Buffer.from(algorithm.additionalData));
                }

                decipher.setAuthTag(tag);
                dec = decipher.update(enc);
                dec = Buffer.concat([dec, decipher.final()]);
                return _context11.abrupt("return", new Uint8Array(dec).buffer);

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function decryptAesGCM(_x32, _x33, _x34) {
        return _decryptAesGCM.apply(this, arguments);
      }

      return decryptAesGCM;
    }()
  }, {
    key: "encryptAesKW",
    value: function () {
      var _encryptAesKW = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(algorithm, key, data) {
        var cipher, enc;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                cipher = crypto__default.createCipheriv("id-aes".concat(key.algorithm.length, "-wrap"), key.data, this.AES_KW_IV);
                enc = cipher.update(data);
                enc = Buffer.concat([enc, cipher.final()]);
                return _context12.abrupt("return", new Uint8Array(enc).buffer);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function encryptAesKW(_x35, _x36, _x37) {
        return _encryptAesKW.apply(this, arguments);
      }

      return encryptAesKW;
    }()
  }, {
    key: "decryptAesKW",
    value: function () {
      var _decryptAesKW = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(algorithm, key, data) {
        var decipher, dec;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                decipher = crypto__default.createDecipheriv("id-aes".concat(key.algorithm.length, "-wrap"), key.data, this.AES_KW_IV);
                dec = decipher.update(data);
                dec = Buffer.concat([dec, decipher.final()]);
                return _context13.abrupt("return", new Uint8Array(dec).buffer);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function decryptAesKW(_x38, _x39, _x40) {
        return _decryptAesKW.apply(this, arguments);
      }

      return decryptAesKW;
    }()
  }, {
    key: "encryptAesECB",
    value: function () {
      var _encryptAesECB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(algorithm, key, data) {
        var cipher, enc, res;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                cipher = crypto__default.createCipheriv("aes-".concat(key.algorithm.length, "-ecb"), key.data, new Uint8Array(0));
                enc = cipher.update(data);
                enc = Buffer.concat([enc, cipher.final()]);
                res = new Uint8Array(enc).buffer;
                return _context14.abrupt("return", res);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function encryptAesECB(_x41, _x42, _x43) {
        return _encryptAesECB.apply(this, arguments);
      }

      return encryptAesECB;
    }()
  }, {
    key: "decryptAesECB",
    value: function () {
      var _decryptAesECB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(algorithm, key, data) {
        var decipher, dec;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                decipher = crypto__default.createDecipheriv("aes-".concat(key.algorithm.length, "-ecb"), key.data, new Uint8Array(0));
                dec = decipher.update(data);
                dec = Buffer.concat([dec, decipher.final()]);
                return _context15.abrupt("return", new Uint8Array(dec).buffer);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function decryptAesECB(_x44, _x45, _x46) {
        return _decryptAesECB.apply(this, arguments);
      }

      return decryptAesECB;
    }()
  }]);

  return AesCrypto;
}();

AesCrypto.AES_KW_IV = Buffer.from("A6A6A6A6A6A6A6A6", "hex");
var keyStorage = new WeakMap();

function getCryptoKey(key) {
  var res = keyStorage.get(key);

  if (!res) {
    throw new core.OperationError("Cannot get CryptoKey from secure storage");
  }

  return res;
}

function setCryptoKey(value) {
  var key = core.CryptoKey.create(value.algorithm, value.type, value.extractable, value.usages);
  Object.freeze(key);
  keyStorage.set(key, value);
  return key;
}

var AesCbcProvider = /*#__PURE__*/function (_core$AesCbcProvider) {
  _inherits(AesCbcProvider, _core$AesCbcProvider);

  var _super5 = _createSuper(AesCbcProvider);

  function AesCbcProvider() {
    _classCallCheck(this, AesCbcProvider);

    return _super5.apply(this, arguments);
  }

  _createClass(AesCbcProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return AesCrypto.generateKey({
                  name: this.name,
                  length: algorithm.length
                }, extractable, keyUsages);

              case 2:
                key = _context16.sent;
                return _context16.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function onGenerateKey(_x47, _x48, _x49) {
        return _onGenerateKey.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function onEncrypt(_x50, _x51, _x52) {
        return _onEncrypt.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function onDecrypt(_x53, _x54, _x55) {
        return _onDecrypt.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(format, key) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", AesCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function onExportKey(_x56, _x57) {
        return _onExportKey.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return AesCrypto.importKey(format, keyData, {
                  name: algorithm.name
                }, extractable, keyUsages);

              case 2:
                key = _context20.sent;
                return _context20.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function onImportKey(_x58, _x59, _x60, _x61, _x62) {
        return _onImportKey.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(AesCbcProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
        throw new TypeError("key: Is not a AesCryptoKey");
      }
    }
  }]);

  return AesCbcProvider;
}(core.AesCbcProvider);

var zero = Buffer.from([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
var rb = Buffer.from([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 135]);
var blockSize = 16;

function bitShiftLeft(buffer) {
  var shifted = Buffer.alloc(buffer.length);
  var last = buffer.length - 1;

  for (var index = 0; index < last; index++) {
    shifted[index] = buffer[index] << 1;

    if (buffer[index + 1] & 0x80) {
      shifted[index] += 0x01;
    }
  }

  shifted[last] = buffer[last] << 1;
  return shifted;
}

function xor(a, b) {
  var length = Math.min(a.length, b.length);
  var output = Buffer.alloc(length);

  for (var index = 0; index < length; index++) {
    output[index] = a[index] ^ b[index];
  }

  return output;
}

function aes(key, message) {
  var cipher = crypto.createCipheriv("aes".concat(key.length << 3), key, zero);
  var result = cipher.update(message);
  cipher.final();
  return result;
}

function getMessageBlock(message, blockIndex) {
  var block = Buffer.alloc(blockSize);
  var start = blockIndex * blockSize;
  var end = start + blockSize;
  message.copy(block, 0, start, end);
  return block;
}

function getPaddedMessageBlock(message, blockIndex) {
  var block = Buffer.alloc(blockSize);
  var start = blockIndex * blockSize;
  var end = message.length;
  block.fill(0);
  message.copy(block, 0, start, end);
  block[end - start] = 0x80;
  return block;
}

function generateSubkeys(key) {
  var l = aes(key, zero);
  var subkey1 = bitShiftLeft(l);

  if (l[0] & 0x80) {
    subkey1 = xor(subkey1, rb);
  }

  var subkey2 = bitShiftLeft(subkey1);

  if (subkey1[0] & 0x80) {
    subkey2 = xor(subkey2, rb);
  }

  return {
    subkey1: subkey1,
    subkey2: subkey2
  };
}

function aesCmac(key, message) {
  var subkeys = generateSubkeys(key);
  var blockCount = Math.ceil(message.length / blockSize);
  var lastBlockCompleteFlag;
  var lastBlock;

  if (blockCount === 0) {
    blockCount = 1;
    lastBlockCompleteFlag = false;
  } else {
    lastBlockCompleteFlag = message.length % blockSize === 0;
  }

  var lastBlockIndex = blockCount - 1;

  if (lastBlockCompleteFlag) {
    lastBlock = xor(getMessageBlock(message, lastBlockIndex), subkeys.subkey1);
  } else {
    lastBlock = xor(getPaddedMessageBlock(message, lastBlockIndex), subkeys.subkey2);
  }

  var x = zero;
  var y;

  for (var index = 0; index < lastBlockIndex; index++) {
    y = xor(x, getMessageBlock(message, index));
    x = aes(key, y);
  }

  y = xor(lastBlock, x);
  return aes(key, y);
}

var AesCmacProvider = /*#__PURE__*/function (_core$AesCmacProvider) {
  _inherits(AesCmacProvider, _core$AesCmacProvider);

  var _super6 = _createSuper(AesCmacProvider);

  function AesCmacProvider() {
    _classCallCheck(this, AesCmacProvider);

    return _super6.apply(this, arguments);
  }

  _createClass(AesCmacProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return AesCrypto.generateKey({
                  name: this.name,
                  length: algorithm.length
                }, extractable, keyUsages);

              case 2:
                key = _context21.sent;
                return _context21.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function onGenerateKey(_x63, _x64, _x65) {
        return _onGenerateKey2.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onSign",
    value: function () {
      var _onSign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(algorithm, key, data) {
        var result;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                result = aesCmac(getCryptoKey(key).data, Buffer.from(data));
                return _context22.abrupt("return", new Uint8Array(result).buffer);

              case 2:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function onSign(_x66, _x67, _x68) {
        return _onSign.apply(this, arguments);
      }

      return onSign;
    }()
  }, {
    key: "onVerify",
    value: function () {
      var _onVerify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(algorithm, key, signature, data) {
        var signature2;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.sign(algorithm, key, data);

              case 2:
                signature2 = _context23.sent;
                return _context23.abrupt("return", Buffer.from(signature).compare(Buffer.from(signature2)) === 0);

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function onVerify(_x69, _x70, _x71, _x72) {
        return _onVerify.apply(this, arguments);
      }

      return onVerify;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(format, key) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", AesCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function onExportKey(_x73, _x74) {
        return _onExportKey2.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(format, keyData, algorithm, extractable, keyUsages) {
        var res;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return AesCrypto.importKey(format, keyData, {
                  name: algorithm.name
                }, extractable, keyUsages);

              case 2:
                res = _context25.sent;
                return _context25.abrupt("return", setCryptoKey(res));

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      function onImportKey(_x75, _x76, _x77, _x78, _x79) {
        return _onImportKey2.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(AesCmacProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
        throw new TypeError("key: Is not a AesCryptoKey");
      }
    }
  }]);

  return AesCmacProvider;
}(core.AesCmacProvider);

var AesCtrProvider = /*#__PURE__*/function (_core$AesCtrProvider) {
  _inherits(AesCtrProvider, _core$AesCtrProvider);

  var _super7 = _createSuper(AesCtrProvider);

  function AesCtrProvider() {
    _classCallCheck(this, AesCtrProvider);

    return _super7.apply(this, arguments);
  }

  _createClass(AesCtrProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return AesCrypto.generateKey({
                  name: this.name,
                  length: algorithm.length
                }, extractable, keyUsages);

              case 2:
                key = _context26.sent;
                return _context26.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function onGenerateKey(_x80, _x81, _x82) {
        return _onGenerateKey3.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      function onEncrypt(_x83, _x84, _x85) {
        return _onEncrypt2.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      function onDecrypt(_x86, _x87, _x88) {
        return _onDecrypt2.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(format, key) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", AesCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      function onExportKey(_x89, _x90) {
        return _onExportKey3.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(format, keyData, algorithm, extractable, keyUsages) {
        var res;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return AesCrypto.importKey(format, keyData, {
                  name: algorithm.name
                }, extractable, keyUsages);

              case 2:
                res = _context30.sent;
                return _context30.abrupt("return", setCryptoKey(res));

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30);
      }));

      function onImportKey(_x91, _x92, _x93, _x94, _x95) {
        return _onImportKey3.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(AesCtrProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
        throw new TypeError("key: Is not a AesCryptoKey");
      }
    }
  }]);

  return AesCtrProvider;
}(core.AesCtrProvider);

var AesGcmProvider = /*#__PURE__*/function (_core$AesGcmProvider) {
  _inherits(AesGcmProvider, _core$AesGcmProvider);

  var _super8 = _createSuper(AesGcmProvider);

  function AesGcmProvider() {
    _classCallCheck(this, AesGcmProvider);

    return _super8.apply(this, arguments);
  }

  _createClass(AesGcmProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return AesCrypto.generateKey({
                  name: this.name,
                  length: algorithm.length
                }, extractable, keyUsages);

              case 2:
                key = _context31.sent;
                return _context31.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function onGenerateKey(_x96, _x97, _x98) {
        return _onGenerateKey4.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                return _context32.abrupt("return", AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      function onEncrypt(_x99, _x100, _x101) {
        return _onEncrypt3.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                return _context33.abrupt("return", AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }));

      function onDecrypt(_x102, _x103, _x104) {
        return _onDecrypt3.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(format, key) {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                return _context34.abrupt("return", AesCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34);
      }));

      function onExportKey(_x105, _x106) {
        return _onExportKey4.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(format, keyData, algorithm, extractable, keyUsages) {
        var res;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return AesCrypto.importKey(format, keyData, {
                  name: algorithm.name
                }, extractable, keyUsages);

              case 2:
                res = _context35.sent;
                return _context35.abrupt("return", setCryptoKey(res));

              case 4:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));

      function onImportKey(_x107, _x108, _x109, _x110, _x111) {
        return _onImportKey4.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(AesGcmProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
        throw new TypeError("key: Is not a AesCryptoKey");
      }
    }
  }]);

  return AesGcmProvider;
}(core.AesGcmProvider);

var AesKwProvider = /*#__PURE__*/function (_core$AesKwProvider) {
  _inherits(AesKwProvider, _core$AesKwProvider);

  var _super9 = _createSuper(AesKwProvider);

  function AesKwProvider() {
    _classCallCheck(this, AesKwProvider);

    return _super9.apply(this, arguments);
  }

  _createClass(AesKwProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(algorithm, extractable, keyUsages) {
        var res;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return AesCrypto.generateKey({
                  name: this.name,
                  length: algorithm.length
                }, extractable, keyUsages);

              case 2:
                res = _context36.sent;
                return _context36.abrupt("return", setCryptoKey(res));

              case 4:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function onGenerateKey(_x112, _x113, _x114) {
        return _onGenerateKey5.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(format, key) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                return _context37.abrupt("return", AesCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37);
      }));

      function onExportKey(_x115, _x116) {
        return _onExportKey5.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(format, keyData, algorithm, extractable, keyUsages) {
        var res;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return AesCrypto.importKey(format, keyData, {
                  name: algorithm.name
                }, extractable, keyUsages);

              case 2:
                res = _context38.sent;
                return _context38.abrupt("return", setCryptoKey(res));

              case 4:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38);
      }));

      function onImportKey(_x117, _x118, _x119, _x120, _x121) {
        return _onImportKey5.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                return _context39.abrupt("return", AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39);
      }));

      function onEncrypt(_x122, _x123, _x124) {
        return _onEncrypt4.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                return _context40.abrupt("return", AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40);
      }));

      function onDecrypt(_x125, _x126, _x127) {
        return _onDecrypt4.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(AesKwProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
        throw new TypeError("key: Is not a AesCryptoKey");
      }
    }
  }]);

  return AesKwProvider;
}(core.AesKwProvider);

var AesEcbProvider = /*#__PURE__*/function (_core$AesEcbProvider) {
  _inherits(AesEcbProvider, _core$AesEcbProvider);

  var _super10 = _createSuper(AesEcbProvider);

  function AesEcbProvider() {
    _classCallCheck(this, AesEcbProvider);

    return _super10.apply(this, arguments);
  }

  _createClass(AesEcbProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return AesCrypto.generateKey({
                  name: this.name,
                  length: algorithm.length
                }, extractable, keyUsages);

              case 2:
                key = _context41.sent;
                return _context41.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function onGenerateKey(_x128, _x129, _x130) {
        return _onGenerateKey6.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                return _context42.abrupt("return", AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42);
      }));

      function onEncrypt(_x131, _x132, _x133) {
        return _onEncrypt5.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                return _context43.abrupt("return", AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43);
      }));

      function onDecrypt(_x134, _x135, _x136) {
        return _onDecrypt5.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(format, key) {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                return _context44.abrupt("return", AesCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44);
      }));

      function onExportKey(_x137, _x138) {
        return _onExportKey6.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(format, keyData, algorithm, extractable, keyUsages) {
        var res;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return AesCrypto.importKey(format, keyData, {
                  name: algorithm.name
                }, extractable, keyUsages);

              case 2:
                res = _context45.sent;
                return _context45.abrupt("return", setCryptoKey(res));

              case 4:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }));

      function onImportKey(_x139, _x140, _x141, _x142, _x143) {
        return _onImportKey6.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(AesEcbProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
        throw new TypeError("key: Is not a AesCryptoKey");
      }
    }
  }]);

  return AesEcbProvider;
}(core.AesEcbProvider);

var DesCryptoKey = /*#__PURE__*/function (_SymmetricKey2) {
  _inherits(DesCryptoKey, _SymmetricKey2);

  var _super11 = _createSuper(DesCryptoKey);

  function DesCryptoKey() {
    _classCallCheck(this, DesCryptoKey);

    return _super11.apply(this, arguments);
  }

  _createClass(DesCryptoKey, [{
    key: "alg",
    get: function get() {
      switch (this.algorithm.name.toUpperCase()) {
        case "DES-CBC":
          return "DES-CBC";

        case "DES-EDE3-CBC":
          return "3DES-CBC";

        default:
          throw new core.AlgorithmError("Unsupported algorithm name");
      }
    },
    set: function set(value) {}
  }]);

  return DesCryptoKey;
}(SymmetricKey);

__decorate([JsonProp({
  name: "k",
  converter: JsonBase64UrlConverter
})], DesCryptoKey.prototype, "data", void 0);

var DesCrypto = /*#__PURE__*/function () {
  function DesCrypto() {
    _classCallCheck(this, DesCrypto);
  }

  _createClass(DesCrypto, null, [{
    key: "generateKey",
    value: function () {
      var _generateKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                key = new DesCryptoKey();
                key.algorithm = algorithm;
                key.extractable = extractable;
                key.usages = keyUsages;
                key.data = crypto__default.randomBytes(algorithm.length >> 3);
                return _context46.abrupt("return", key);

              case 6:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }));

      function generateKey(_x144, _x145, _x146) {
        return _generateKey2.apply(this, arguments);
      }

      return generateKey;
    }()
  }, {
    key: "exportKey",
    value: function () {
      var _exportKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(format, key) {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.t0 = format.toLowerCase();
                _context47.next = _context47.t0 === "jwk" ? 3 : _context47.t0 === "raw" ? 4 : 5;
                break;

              case 3:
                return _context47.abrupt("return", JsonSerializer.toJSON(key));

              case 4:
                return _context47.abrupt("return", new Uint8Array(key.data).buffer);

              case 5:
                throw new core.OperationError("format: Must be 'jwk' or 'raw'");

              case 6:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47);
      }));

      function exportKey(_x147, _x148) {
        return _exportKey2.apply(this, arguments);
      }

      return exportKey;
    }()
  }, {
    key: "importKey",
    value: function () {
      var _importKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.t0 = format.toLowerCase();
                _context48.next = _context48.t0 === "jwk" ? 3 : _context48.t0 === "raw" ? 5 : 8;
                break;

              case 3:
                key = JsonParser.fromJSON(keyData, {
                  targetSchema: DesCryptoKey
                });
                return _context48.abrupt("break", 9);

              case 5:
                key = new DesCryptoKey();
                key.data = Buffer.from(keyData);
                return _context48.abrupt("break", 9);

              case 8:
                throw new core.OperationError("format: Must be 'jwk' or 'raw'");

              case 9:
                key.algorithm = algorithm;
                key.extractable = extractable;
                key.usages = keyUsages;
                return _context48.abrupt("return", key);

              case 13:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48);
      }));

      function importKey(_x149, _x150, _x151, _x152, _x153) {
        return _importKey2.apply(this, arguments);
      }

      return importKey;
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.t0 = algorithm.name.toUpperCase();
                _context49.next = _context49.t0 === "DES-CBC" ? 3 : _context49.t0 === "DES-EDE3-CBC" ? 4 : 5;
                break;

              case 3:
                return _context49.abrupt("return", this.encryptDesCBC(algorithm, key, Buffer.from(data)));

              case 4:
                return _context49.abrupt("return", this.encryptDesEDE3CBC(algorithm, key, Buffer.from(data)));

              case 5:
                throw new core.OperationError("algorithm: Is not recognized");

              case 6:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function encrypt(_x154, _x155, _x156) {
        return _encrypt2.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                if (key instanceof DesCryptoKey) {
                  _context50.next = 2;
                  break;
                }

                throw new Error("key: Is not DesCryptoKey");

              case 2:
                _context50.t0 = algorithm.name.toUpperCase();
                _context50.next = _context50.t0 === "DES-CBC" ? 5 : _context50.t0 === "DES-EDE3-CBC" ? 6 : 7;
                break;

              case 5:
                return _context50.abrupt("return", this.decryptDesCBC(algorithm, key, Buffer.from(data)));

              case 6:
                return _context50.abrupt("return", this.decryptDesEDE3CBC(algorithm, key, Buffer.from(data)));

              case 7:
                throw new core.OperationError("algorithm: Is not recognized");

              case 8:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function decrypt(_x157, _x158, _x159) {
        return _decrypt2.apply(this, arguments);
      }

      return decrypt;
    }()
  }, {
    key: "encryptDesCBC",
    value: function () {
      var _encryptDesCBC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(algorithm, key, data) {
        var cipher, enc, res;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                cipher = crypto__default.createCipheriv("des-cbc", key.data, new Uint8Array(algorithm.iv));
                enc = cipher.update(data);
                enc = Buffer.concat([enc, cipher.final()]);
                res = new Uint8Array(enc).buffer;
                return _context51.abrupt("return", res);

              case 5:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51);
      }));

      function encryptDesCBC(_x160, _x161, _x162) {
        return _encryptDesCBC.apply(this, arguments);
      }

      return encryptDesCBC;
    }()
  }, {
    key: "decryptDesCBC",
    value: function () {
      var _decryptDesCBC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(algorithm, key, data) {
        var decipher, dec;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                decipher = crypto__default.createDecipheriv("des-cbc", key.data, new Uint8Array(algorithm.iv));
                dec = decipher.update(data);
                dec = Buffer.concat([dec, decipher.final()]);
                return _context52.abrupt("return", new Uint8Array(dec).buffer);

              case 4:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52);
      }));

      function decryptDesCBC(_x163, _x164, _x165) {
        return _decryptDesCBC.apply(this, arguments);
      }

      return decryptDesCBC;
    }()
  }, {
    key: "encryptDesEDE3CBC",
    value: function () {
      var _encryptDesEDE3CBC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(algorithm, key, data) {
        var cipher, enc, res;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                cipher = crypto__default.createCipheriv("des-ede3-cbc", key.data, Buffer.from(algorithm.iv));
                enc = cipher.update(data);
                enc = Buffer.concat([enc, cipher.final()]);
                res = new Uint8Array(enc).buffer;
                return _context53.abrupt("return", res);

              case 5:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53);
      }));

      function encryptDesEDE3CBC(_x166, _x167, _x168) {
        return _encryptDesEDE3CBC.apply(this, arguments);
      }

      return encryptDesEDE3CBC;
    }()
  }, {
    key: "decryptDesEDE3CBC",
    value: function () {
      var _decryptDesEDE3CBC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(algorithm, key, data) {
        var decipher, dec;
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                decipher = crypto__default.createDecipheriv("des-ede3-cbc", key.data, new Uint8Array(algorithm.iv));
                dec = decipher.update(data);
                dec = Buffer.concat([dec, decipher.final()]);
                return _context54.abrupt("return", new Uint8Array(dec).buffer);

              case 4:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54);
      }));

      function decryptDesEDE3CBC(_x169, _x170, _x171) {
        return _decryptDesEDE3CBC.apply(this, arguments);
      }

      return decryptDesEDE3CBC;
    }()
  }]);

  return DesCrypto;
}();

var DesCbcProvider = /*#__PURE__*/function (_core$DesProvider) {
  _inherits(DesCbcProvider, _core$DesProvider);

  var _super12 = _createSuper(DesCbcProvider);

  function DesCbcProvider() {
    var _this3;

    _classCallCheck(this, DesCbcProvider);

    _this3 = _super12.apply(this, arguments);
    _this3.keySizeBits = 64;
    _this3.ivSize = 8;
    _this3.name = "DES-CBC";
    return _this3;
  }

  _createClass(DesCbcProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.next = 2;
                return DesCrypto.generateKey({
                  name: this.name,
                  length: this.keySizeBits
                }, extractable, keyUsages);

              case 2:
                key = _context55.sent;
                return _context55.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function onGenerateKey(_x172, _x173, _x174) {
        return _onGenerateKey7.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                return _context56.abrupt("return", DesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56);
      }));

      function onEncrypt(_x175, _x176, _x177) {
        return _onEncrypt6.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                return _context57.abrupt("return", DesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57);
      }));

      function onDecrypt(_x178, _x179, _x180) {
        return _onDecrypt6.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(format, key) {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                return _context58.abrupt("return", DesCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58);
      }));

      function onExportKey(_x181, _x182) {
        return _onExportKey7.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return DesCrypto.importKey(format, keyData, {
                  name: this.name,
                  length: this.keySizeBits
                }, extractable, keyUsages);

              case 2:
                key = _context59.sent;

                if (!(key.data.length !== this.keySizeBits >> 3)) {
                  _context59.next = 5;
                  break;
                }

                throw new core.OperationError("keyData: Wrong key size");

              case 5:
                return _context59.abrupt("return", setCryptoKey(key));

              case 6:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));

      function onImportKey(_x183, _x184, _x185, _x186, _x187) {
        return _onImportKey7.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(DesCbcProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof DesCryptoKey)) {
        throw new TypeError("key: Is not a DesCryptoKey");
      }
    }
  }]);

  return DesCbcProvider;
}(core.DesProvider);

var DesEde3CbcProvider = /*#__PURE__*/function (_core$DesProvider2) {
  _inherits(DesEde3CbcProvider, _core$DesProvider2);

  var _super13 = _createSuper(DesEde3CbcProvider);

  function DesEde3CbcProvider() {
    var _this4;

    _classCallCheck(this, DesEde3CbcProvider);

    _this4 = _super13.apply(this, arguments);
    _this4.keySizeBits = 192;
    _this4.ivSize = 8;
    _this4.name = "DES-EDE3-CBC";
    return _this4;
  }

  _createClass(DesEde3CbcProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return DesCrypto.generateKey({
                  name: this.name,
                  length: this.keySizeBits
                }, extractable, keyUsages);

              case 2:
                key = _context60.sent;
                return _context60.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function onGenerateKey(_x188, _x189, _x190) {
        return _onGenerateKey8.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                return _context61.abrupt("return", DesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61);
      }));

      function onEncrypt(_x191, _x192, _x193) {
        return _onEncrypt7.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                return _context62.abrupt("return", DesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62);
      }));

      function onDecrypt(_x194, _x195, _x196) {
        return _onDecrypt7.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(format, key) {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                return _context63.abrupt("return", DesCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63);
      }));

      function onExportKey(_x197, _x198) {
        return _onExportKey8.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.next = 2;
                return DesCrypto.importKey(format, keyData, {
                  name: this.name,
                  length: this.keySizeBits
                }, extractable, keyUsages);

              case 2:
                key = _context64.sent;

                if (!(key.data.length !== this.keySizeBits >> 3)) {
                  _context64.next = 5;
                  break;
                }

                throw new core.OperationError("keyData: Wrong key size");

              case 5:
                return _context64.abrupt("return", setCryptoKey(key));

              case 6:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function onImportKey(_x199, _x200, _x201, _x202, _x203) {
        return _onImportKey8.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(DesEde3CbcProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof DesCryptoKey)) {
        throw new TypeError("key: Is not a DesCryptoKey");
      }
    }
  }]);

  return DesEde3CbcProvider;
}(core.DesProvider);

function getJwkAlgorithm(algorithm) {
  switch (algorithm.name.toUpperCase()) {
    case "RSA-OAEP":
      {
        var mdSize = /(\d+)$/.exec(algorithm.hash.name)[1];
        return "RSA-OAEP".concat(mdSize !== "1" ? "-".concat(mdSize) : "");
      }

    case "RSASSA-PKCS1-V1_5":
      return "RS".concat(/(\d+)$/.exec(algorithm.hash.name)[1]);

    case "RSA-PSS":
      return "PS".concat(/(\d+)$/.exec(algorithm.hash.name)[1]);

    case "RSA-PKCS1":
      return "RS1";

    default:
      throw new core.OperationError("algorithm: Is not recognized");
  }
}

var RsaPrivateKey = /*#__PURE__*/function (_AsymmetricKey) {
  _inherits(RsaPrivateKey, _AsymmetricKey);

  var _super14 = _createSuper(RsaPrivateKey);

  function RsaPrivateKey() {
    var _this5;

    _classCallCheck(this, RsaPrivateKey);

    _this5 = _super14.apply(this, arguments);
    _this5.type = "private";
    return _this5;
  }

  _createClass(RsaPrivateKey, [{
    key: "getKey",
    value: function getKey() {
      var keyInfo = AsnParser.parse(this.data, core.asn1.PrivateKeyInfo);
      return AsnParser.parse(keyInfo.privateKey, core.asn1.RsaPrivateKey);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var key = this.getKey();
      var json = {
        kty: "RSA",
        alg: getJwkAlgorithm(this.algorithm),
        key_ops: this.usages,
        ext: this.extractable
      };
      return Object.assign(json, JsonSerializer.toJSON(key));
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var key = JsonParser.fromJSON(json, {
        targetSchema: core.asn1.RsaPrivateKey
      });
      var keyInfo = new core.asn1.PrivateKeyInfo();
      keyInfo.privateKeyAlgorithm.algorithm = "1.2.840.113549.1.1.1";
      keyInfo.privateKeyAlgorithm.parameters = null;
      keyInfo.privateKey = AsnSerializer.serialize(key);
      this.data = Buffer.from(AsnSerializer.serialize(keyInfo));
    }
  }]);

  return RsaPrivateKey;
}(AsymmetricKey);

var RsaPublicKey = /*#__PURE__*/function (_AsymmetricKey2) {
  _inherits(RsaPublicKey, _AsymmetricKey2);

  var _super15 = _createSuper(RsaPublicKey);

  function RsaPublicKey() {
    var _this6;

    _classCallCheck(this, RsaPublicKey);

    _this6 = _super15.apply(this, arguments);
    _this6.type = "public";
    return _this6;
  }

  _createClass(RsaPublicKey, [{
    key: "getKey",
    value: function getKey() {
      var keyInfo = AsnParser.parse(this.data, core.asn1.PublicKeyInfo);
      return AsnParser.parse(keyInfo.publicKey, core.asn1.RsaPublicKey);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var key = this.getKey();
      var json = {
        kty: "RSA",
        alg: getJwkAlgorithm(this.algorithm),
        key_ops: this.usages,
        ext: this.extractable
      };
      return Object.assign(json, JsonSerializer.toJSON(key));
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var key = JsonParser.fromJSON(json, {
        targetSchema: core.asn1.RsaPublicKey
      });
      var keyInfo = new core.asn1.PublicKeyInfo();
      keyInfo.publicKeyAlgorithm.algorithm = "1.2.840.113549.1.1.1";
      keyInfo.publicKeyAlgorithm.parameters = null;
      keyInfo.publicKey = AsnSerializer.serialize(key);
      this.data = Buffer.from(AsnSerializer.serialize(keyInfo));
    }
  }]);

  return RsaPublicKey;
}(AsymmetricKey);

var RsaCrypto = /*#__PURE__*/function () {
  function RsaCrypto() {
    _classCallCheck(this, RsaCrypto);
  }

  _createClass(RsaCrypto, null, [{
    key: "generateKey",
    value: function () {
      var _generateKey3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(algorithm, extractable, keyUsages) {
        var _this7 = this;

        var privateKey, publicKey, publicExponent, keys, res;
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                privateKey = new RsaPrivateKey();
                privateKey.algorithm = algorithm;
                privateKey.extractable = extractable;
                privateKey.usages = keyUsages.filter(function (usage) {
                  return _this7.privateKeyUsages.indexOf(usage) !== -1;
                });
                publicKey = new RsaPublicKey();
                publicKey.algorithm = algorithm;
                publicKey.extractable = true;
                publicKey.usages = keyUsages.filter(function (usage) {
                  return _this7.publicKeyUsages.indexOf(usage) !== -1;
                });
                publicExponent = Buffer.concat([Buffer.alloc(4 - algorithm.publicExponent.byteLength, 0), Buffer.from(algorithm.publicExponent)]).readInt32BE(0);
                keys = crypto__default.generateKeyPairSync("rsa", {
                  modulusLength: algorithm.modulusLength,
                  publicExponent: publicExponent,
                  publicKeyEncoding: {
                    format: "der",
                    type: "spki"
                  },
                  privateKeyEncoding: {
                    format: "der",
                    type: "pkcs8"
                  }
                });
                privateKey.data = keys.privateKey;
                publicKey.data = keys.publicKey;
                res = {
                  privateKey: privateKey,
                  publicKey: publicKey
                };
                return _context65.abrupt("return", res);

              case 14:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65);
      }));

      function generateKey(_x204, _x205, _x206) {
        return _generateKey3.apply(this, arguments);
      }

      return generateKey;
    }()
  }, {
    key: "exportKey",
    value: function () {
      var _exportKey3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(format, key) {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                _context66.t0 = format.toLowerCase();
                _context66.next = _context66.t0 === "jwk" ? 3 : _context66.t0 === "pkcs8" ? 4 : _context66.t0 === "spki" ? 4 : 5;
                break;

              case 3:
                return _context66.abrupt("return", JsonSerializer.toJSON(key));

              case 4:
                return _context66.abrupt("return", new Uint8Array(key.data).buffer);

              case 5:
                throw new core.OperationError("format: Must be 'jwk', 'pkcs8' or 'spki'");

              case 6:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66);
      }));

      function exportKey(_x207, _x208) {
        return _exportKey3.apply(this, arguments);
      }

      return exportKey;
    }()
  }, {
    key: "importKey",
    value: function () {
      var _importKey3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(format, keyData, algorithm, extractable, keyUsages) {
        var jwk, asnKey, _asnKey, keyInfo, _asnKey2, _keyInfo, _asnKey3;

        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _context67.t0 = format.toLowerCase();
                _context67.next = _context67.t0 === "jwk" ? 3 : _context67.t0 === "spki" ? 11 : _context67.t0 === "pkcs8" ? 14 : 17;
                break;

              case 3:
                jwk = keyData;

                if (!jwk.d) {
                  _context67.next = 9;
                  break;
                }

                asnKey = JsonParser.fromJSON(keyData, {
                  targetSchema: core.asn1.RsaPrivateKey
                });
                return _context67.abrupt("return", this.importPrivateKey(asnKey, algorithm, extractable, keyUsages));

              case 9:
                _asnKey = JsonParser.fromJSON(keyData, {
                  targetSchema: core.asn1.RsaPublicKey
                });
                return _context67.abrupt("return", this.importPublicKey(_asnKey, algorithm, extractable, keyUsages));

              case 11:
                keyInfo = AsnParser.parse(new Uint8Array(keyData), core.asn1.PublicKeyInfo);
                _asnKey2 = AsnParser.parse(keyInfo.publicKey, core.asn1.RsaPublicKey);
                return _context67.abrupt("return", this.importPublicKey(_asnKey2, algorithm, extractable, keyUsages));

              case 14:
                _keyInfo = AsnParser.parse(new Uint8Array(keyData), core.asn1.PrivateKeyInfo);
                _asnKey3 = AsnParser.parse(_keyInfo.privateKey, core.asn1.RsaPrivateKey);
                return _context67.abrupt("return", this.importPrivateKey(_asnKey3, algorithm, extractable, keyUsages));

              case 17:
                throw new core.OperationError("format: Must be 'jwk', 'pkcs8' or 'spki'");

              case 18:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function importKey(_x209, _x210, _x211, _x212, _x213) {
        return _importKey3.apply(this, arguments);
      }

      return importKey;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.t0 = algorithm.name.toUpperCase();
                _context68.next = _context68.t0 === "RSA-PSS" ? 3 : _context68.t0 === "RSASSA-PKCS1-V1_5" ? 3 : 4;
                break;

              case 3:
                return _context68.abrupt("return", this.signRsa(algorithm, key, data));

              case 4:
                throw new core.OperationError("algorithm: Is not recognized");

              case 5:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function sign(_x214, _x215, _x216) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(algorithm, key, signature, data) {
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                _context69.t0 = algorithm.name.toUpperCase();
                _context69.next = _context69.t0 === "RSA-PSS" ? 3 : _context69.t0 === "RSASSA-PKCS1-V1_5" ? 3 : 4;
                break;

              case 3:
                return _context69.abrupt("return", this.verifySSA(algorithm, key, data, signature));

              case 4:
                throw new core.OperationError("algorithm: Is not recognized");

              case 5:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function verify(_x217, _x218, _x219, _x220) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                _context70.t0 = algorithm.name.toUpperCase();
                _context70.next = _context70.t0 === "RSA-OAEP" ? 3 : 4;
                break;

              case 3:
                return _context70.abrupt("return", this.encryptOAEP(algorithm, key, data));

              case 4:
                throw new core.OperationError("algorithm: Is not recognized");

              case 5:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));

      function encrypt(_x221, _x222, _x223) {
        return _encrypt3.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                _context71.t0 = algorithm.name.toUpperCase();
                _context71.next = _context71.t0 === "RSA-OAEP" ? 3 : 4;
                break;

              case 3:
                return _context71.abrupt("return", this.decryptOAEP(algorithm, key, data));

              case 4:
                throw new core.OperationError("algorithm: Is not recognized");

              case 5:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));

      function decrypt(_x224, _x225, _x226) {
        return _decrypt3.apply(this, arguments);
      }

      return decrypt;
    }()
  }, {
    key: "importPrivateKey",
    value: function importPrivateKey(asnKey, algorithm, extractable, keyUsages) {
      var keyInfo = new core.asn1.PrivateKeyInfo();
      keyInfo.privateKeyAlgorithm.algorithm = "1.2.840.113549.1.1.1";
      keyInfo.privateKeyAlgorithm.parameters = null;
      keyInfo.privateKey = AsnSerializer.serialize(asnKey);
      var key = new RsaPrivateKey();
      key.data = Buffer.from(AsnSerializer.serialize(keyInfo));
      key.algorithm = Object.assign({}, algorithm);
      key.algorithm.publicExponent = new Uint8Array(asnKey.publicExponent);
      key.algorithm.modulusLength = asnKey.modulus.byteLength << 3;
      key.extractable = extractable;
      key.usages = keyUsages;
      return key;
    }
  }, {
    key: "importPublicKey",
    value: function importPublicKey(asnKey, algorithm, extractable, keyUsages) {
      var keyInfo = new core.asn1.PublicKeyInfo();
      keyInfo.publicKeyAlgorithm.algorithm = "1.2.840.113549.1.1.1";
      keyInfo.publicKeyAlgorithm.parameters = null;
      keyInfo.publicKey = AsnSerializer.serialize(asnKey);
      var key = new RsaPublicKey();
      key.data = Buffer.from(AsnSerializer.serialize(keyInfo));
      key.algorithm = Object.assign({}, algorithm);
      key.algorithm.publicExponent = new Uint8Array(asnKey.publicExponent);
      key.algorithm.modulusLength = asnKey.modulus.byteLength << 3;
      key.extractable = extractable;
      key.usages = keyUsages;
      return key;
    }
  }, {
    key: "getCryptoAlgorithm",
    value: function getCryptoAlgorithm(alg) {
      switch (alg.hash.name.toUpperCase()) {
        case "SHA-1":
          return "RSA-SHA1";

        case "SHA-256":
          return "RSA-SHA256";

        case "SHA-384":
          return "RSA-SHA384";

        case "SHA-512":
          return "RSA-SHA512";

        case "SHA3-256":
          return "RSA-SHA3-256";

        case "SHA3-384":
          return "RSA-SHA3-384";

        case "SHA3-512":
          return "RSA-SHA3-512";

        default:
          throw new core.OperationError("algorithm.hash: Is not recognized");
      }
    }
  }, {
    key: "signRsa",
    value: function signRsa(algorithm, key, data) {
      var cryptoAlg = this.getCryptoAlgorithm(key.algorithm);
      var signer = crypto__default.createSign(cryptoAlg);
      signer.update(Buffer.from(data));

      if (!key.pem) {
        key.pem = "-----BEGIN PRIVATE KEY-----\n".concat(key.data.toString("base64"), "\n-----END PRIVATE KEY-----");
      }

      var options = {
        key: key.pem
      };

      if (algorithm.name.toUpperCase() === "RSA-PSS") {
        options.padding = crypto__default.constants.RSA_PKCS1_PSS_PADDING;
        options.saltLength = algorithm.saltLength;
      }

      var signature = signer.sign(options);
      return new Uint8Array(signature).buffer;
    }
  }, {
    key: "verifySSA",
    value: function verifySSA(algorithm, key, data, signature) {
      var cryptoAlg = this.getCryptoAlgorithm(key.algorithm);
      var signer = crypto__default.createVerify(cryptoAlg);
      signer.update(Buffer.from(data));

      if (!key.pem) {
        key.pem = "-----BEGIN PUBLIC KEY-----\n".concat(key.data.toString("base64"), "\n-----END PUBLIC KEY-----");
      }

      var options = {
        key: key.pem
      };

      if (algorithm.name.toUpperCase() === "RSA-PSS") {
        options.padding = crypto__default.constants.RSA_PKCS1_PSS_PADDING;
        options.saltLength = algorithm.saltLength;
      }

      var ok = signer.verify(options, signature);
      return ok;
    }
  }, {
    key: "encryptOAEP",
    value: function encryptOAEP(algorithm, key, data) {
      var options = {
        key: "-----BEGIN PUBLIC KEY-----\n".concat(key.data.toString("base64"), "\n-----END PUBLIC KEY-----"),
        padding: crypto__default.constants.RSA_PKCS1_OAEP_PADDING
      };
      if (algorithm.label) ;
      return new Uint8Array(crypto__default.publicEncrypt(options, data)).buffer;
    }
  }, {
    key: "decryptOAEP",
    value: function decryptOAEP(algorithm, key, data) {
      var options = {
        key: "-----BEGIN PRIVATE KEY-----\n".concat(key.data.toString("base64"), "\n-----END PRIVATE KEY-----"),
        padding: crypto__default.constants.RSA_PKCS1_OAEP_PADDING
      };
      if (algorithm.label) ;
      return new Uint8Array(crypto__default.privateDecrypt(options, data)).buffer;
    }
  }]);

  return RsaCrypto;
}();

RsaCrypto.publicKeyUsages = ["verify", "encrypt", "wrapKey"];
RsaCrypto.privateKeyUsages = ["sign", "decrypt", "unwrapKey"];

var RsaSsaProvider = /*#__PURE__*/function (_core$RsaSsaProvider) {
  _inherits(RsaSsaProvider, _core$RsaSsaProvider);

  var _super16 = _createSuper(RsaSsaProvider);

  function RsaSsaProvider() {
    var _this8;

    _classCallCheck(this, RsaSsaProvider);

    _this8 = _super16.apply(this, arguments);
    _this8.hashAlgorithms = ["SHA-1", "SHA-256", "SHA-384", "SHA-512", "shake128", "shake256", "SHA3-256", "SHA3-384", "SHA3-512"];
    return _this8;
  }

  _createClass(RsaSsaProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(algorithm, extractable, keyUsages) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                _context72.next = 2;
                return RsaCrypto.generateKey(_objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                keys = _context72.sent;
                return _context72.abrupt("return", {
                  privateKey: setCryptoKey(keys.privateKey),
                  publicKey: setCryptoKey(keys.publicKey)
                });

              case 4:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));

      function onGenerateKey(_x227, _x228, _x229) {
        return _onGenerateKey9.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onSign",
    value: function () {
      var _onSign2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                return _context73.abrupt("return", RsaCrypto.sign(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73);
      }));

      function onSign(_x230, _x231, _x232) {
        return _onSign2.apply(this, arguments);
      }

      return onSign;
    }()
  }, {
    key: "onVerify",
    value: function () {
      var _onVerify2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(algorithm, key, signature, data) {
        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                return _context74.abrupt("return", RsaCrypto.verify(algorithm, getCryptoKey(key), new Uint8Array(signature), new Uint8Array(data)));

              case 1:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74);
      }));

      function onVerify(_x233, _x234, _x235, _x236) {
        return _onVerify2.apply(this, arguments);
      }

      return onVerify;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(format, key) {
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                return _context75.abrupt("return", RsaCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75);
      }));

      function onExportKey(_x237, _x238) {
        return _onExportKey9.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                _context76.next = 2;
                return RsaCrypto.importKey(format, keyData, _objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                key = _context76.sent;
                return _context76.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));

      function onImportKey(_x239, _x240, _x241, _x242, _x243) {
        return _onImportKey9.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(RsaSsaProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      var internalKey = getCryptoKey(key);

      if (!(internalKey instanceof RsaPrivateKey || internalKey instanceof RsaPublicKey)) {
        throw new TypeError("key: Is not RSA CryptoKey");
      }
    }
  }]);

  return RsaSsaProvider;
}(core.RsaSsaProvider);

var RsaPssProvider = /*#__PURE__*/function (_core$RsaPssProvider) {
  _inherits(RsaPssProvider, _core$RsaPssProvider);

  var _super17 = _createSuper(RsaPssProvider);

  function RsaPssProvider() {
    var _this9;

    _classCallCheck(this, RsaPssProvider);

    _this9 = _super17.apply(this, arguments);
    _this9.hashAlgorithms = ["SHA-1", "SHA-256", "SHA-384", "SHA-512", "shake128", "shake256", "SHA3-256", "SHA3-384", "SHA3-512"];
    return _this9;
  }

  _createClass(RsaPssProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(algorithm, extractable, keyUsages) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                _context77.next = 2;
                return RsaCrypto.generateKey(_objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                keys = _context77.sent;
                return _context77.abrupt("return", {
                  privateKey: setCryptoKey(keys.privateKey),
                  publicKey: setCryptoKey(keys.publicKey)
                });

              case 4:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));

      function onGenerateKey(_x244, _x245, _x246) {
        return _onGenerateKey10.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onSign",
    value: function () {
      var _onSign3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                return _context78.abrupt("return", RsaCrypto.sign(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78);
      }));

      function onSign(_x247, _x248, _x249) {
        return _onSign3.apply(this, arguments);
      }

      return onSign;
    }()
  }, {
    key: "onVerify",
    value: function () {
      var _onVerify3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(algorithm, key, signature, data) {
        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                return _context79.abrupt("return", RsaCrypto.verify(algorithm, getCryptoKey(key), new Uint8Array(signature), new Uint8Array(data)));

              case 1:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79);
      }));

      function onVerify(_x250, _x251, _x252, _x253) {
        return _onVerify3.apply(this, arguments);
      }

      return onVerify;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(format, key) {
        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                return _context80.abrupt("return", RsaCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80);
      }));

      function onExportKey(_x254, _x255) {
        return _onExportKey10.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                _context81.next = 2;
                return RsaCrypto.importKey(format, keyData, _objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                key = _context81.sent;
                return _context81.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, this);
      }));

      function onImportKey(_x256, _x257, _x258, _x259, _x260) {
        return _onImportKey10.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(RsaPssProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      var internalKey = getCryptoKey(key);

      if (!(internalKey instanceof RsaPrivateKey || internalKey instanceof RsaPublicKey)) {
        throw new TypeError("key: Is not RSA CryptoKey");
      }
    }
  }]);

  return RsaPssProvider;
}(core.RsaPssProvider);

var ShaCrypto = /*#__PURE__*/function () {
  function ShaCrypto() {
    _classCallCheck(this, ShaCrypto);
  }

  _createClass(ShaCrypto, null, [{
    key: "size",
    value: function size(algorithm) {
      switch (algorithm.name.toUpperCase()) {
        case "SHA-1":
          return 160;

        case "SHA-256":
        case "SHA3-256":
          return 256;

        case "SHA-384":
        case "SHA3-384":
          return 384;

        case "SHA-512":
        case "SHA3-512":
          return 512;

        default:
          throw new Error("Unrecognized name");
      }
    }
  }, {
    key: "getAlgorithmName",
    value: function getAlgorithmName(algorithm) {
      switch (algorithm.name.toUpperCase()) {
        case "SHA-1":
          return "sha1";

        case "SHA-256":
          return "sha256";

        case "SHA-384":
          return "sha384";

        case "SHA-512":
          return "sha512";

        case "SHA3-256":
          return "sha3-256";

        case "SHA3-384":
          return "sha3-384";

        case "SHA3-512":
          return "sha3-512";

        default:
          throw new Error("Unrecognized name");
      }
    }
  }, {
    key: "digest",
    value: function digest(algorithm, data) {
      var hashAlg = this.getAlgorithmName(algorithm);
      var hash = crypto__default.createHash(hashAlg).update(Buffer.from(data)).digest();
      return new Uint8Array(hash).buffer;
    }
  }]);

  return ShaCrypto;
}();

var RsaOaepProvider = /*#__PURE__*/function (_core$RsaOaepProvider) {
  _inherits(RsaOaepProvider, _core$RsaOaepProvider);

  var _super18 = _createSuper(RsaOaepProvider);

  function RsaOaepProvider() {
    _classCallCheck(this, RsaOaepProvider);

    return _super18.apply(this, arguments);
  }

  _createClass(RsaOaepProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(algorithm, extractable, keyUsages) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                _context82.next = 2;
                return RsaCrypto.generateKey(_objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                keys = _context82.sent;
                return _context82.abrupt("return", {
                  privateKey: setCryptoKey(keys.privateKey),
                  publicKey: setCryptoKey(keys.publicKey)
                });

              case 4:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, this);
      }));

      function onGenerateKey(_x261, _x262, _x263) {
        return _onGenerateKey11.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83(algorithm, key, data) {
        var internalKey, dataView, keySize, hashSize, dataLength, psLength, message, seed, dataBlock, labelHash, dataBlockMask, i, seedMask, _i, pkcs0;

        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                internalKey = getCryptoKey(key);
                dataView = new Uint8Array(data);
                keySize = Math.ceil(internalKey.algorithm.modulusLength >> 3);
                hashSize = ShaCrypto.size(internalKey.algorithm.hash) >> 3;
                dataLength = dataView.byteLength;
                psLength = keySize - dataLength - 2 * hashSize - 2;

                if (!(dataLength > keySize - 2 * hashSize - 2)) {
                  _context83.next = 8;
                  break;
                }

                throw new Error("Data too large");

              case 8:
                message = new Uint8Array(keySize);
                seed = message.subarray(1, hashSize + 1);
                dataBlock = message.subarray(hashSize + 1);
                dataBlock.set(dataView, hashSize + psLength + 1);
                labelHash = crypto__default.createHash(internalKey.algorithm.hash.name.replace("-", "")).update(core.BufferSourceConverter.toUint8Array(algorithm.label || new Uint8Array(0))).digest();
                dataBlock.set(labelHash, 0);
                dataBlock[hashSize + psLength] = 1;
                crypto__default.randomFillSync(seed);
                dataBlockMask = this.mgf1(internalKey.algorithm.hash, seed, dataBlock.length);

                for (i = 0; i < dataBlock.length; i++) {
                  dataBlock[i] ^= dataBlockMask[i];
                }

                seedMask = this.mgf1(internalKey.algorithm.hash, dataBlock, seed.length);

                for (_i = 0; _i < seed.length; _i++) {
                  seed[_i] ^= seedMask[_i];
                }

                if (!internalKey.pem) {
                  internalKey.pem = "-----BEGIN PUBLIC KEY-----\n".concat(internalKey.data.toString("base64"), "\n-----END PUBLIC KEY-----");
                }

                pkcs0 = crypto__default.publicEncrypt({
                  key: internalKey.pem,
                  padding: crypto__default.constants.RSA_NO_PADDING
                }, Buffer.from(message));
                return _context83.abrupt("return", new Uint8Array(pkcs0).buffer);

              case 23:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, this);
      }));

      function onEncrypt(_x264, _x265, _x266) {
        return _onEncrypt8.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(algorithm, key, data) {
        var internalKey, keySize, hashSize, dataLength, pkcs0, z, seed, dataBlock, seedMask, i, dataBlockMask, _i2, labelHash, _i3, psEnd, psz;

        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                internalKey = getCryptoKey(key);
                keySize = Math.ceil(internalKey.algorithm.modulusLength >> 3);
                hashSize = ShaCrypto.size(internalKey.algorithm.hash) >> 3;
                dataLength = data.byteLength;

                if (!(dataLength !== keySize)) {
                  _context84.next = 6;
                  break;
                }

                throw new Error("Bad data");

              case 6:
                if (!internalKey.pem) {
                  internalKey.pem = "-----BEGIN PRIVATE KEY-----\n".concat(internalKey.data.toString("base64"), "\n-----END PRIVATE KEY-----");
                }

                pkcs0 = crypto__default.privateDecrypt({
                  key: internalKey.pem,
                  padding: crypto__default.constants.RSA_NO_PADDING
                }, Buffer.from(data));
                z = pkcs0[0];
                seed = pkcs0.subarray(1, hashSize + 1);
                dataBlock = pkcs0.subarray(hashSize + 1);

                if (!(z !== 0)) {
                  _context84.next = 13;
                  break;
                }

                throw new Error("Decryption failed");

              case 13:
                seedMask = this.mgf1(internalKey.algorithm.hash, dataBlock, seed.length);

                for (i = 0; i < seed.length; i++) {
                  seed[i] ^= seedMask[i];
                }

                dataBlockMask = this.mgf1(internalKey.algorithm.hash, seed, dataBlock.length);

                for (_i2 = 0; _i2 < dataBlock.length; _i2++) {
                  dataBlock[_i2] ^= dataBlockMask[_i2];
                }

                labelHash = crypto__default.createHash(internalKey.algorithm.hash.name.replace("-", "")).update(core.BufferSourceConverter.toUint8Array(algorithm.label || new Uint8Array(0))).digest();
                _i3 = 0;

              case 19:
                if (!(_i3 < hashSize)) {
                  _context84.next = 25;
                  break;
                }

                if (!(labelHash[_i3] !== dataBlock[_i3])) {
                  _context84.next = 22;
                  break;
                }

                throw new Error("Decryption failed");

              case 22:
                _i3++;
                _context84.next = 19;
                break;

              case 25:
                psEnd = hashSize;

              case 26:
                if (!(psEnd < dataBlock.length)) {
                  _context84.next = 35;
                  break;
                }

                psz = dataBlock[psEnd];

                if (!(psz === 1)) {
                  _context84.next = 30;
                  break;
                }

                return _context84.abrupt("break", 35);

              case 30:
                if (!(psz !== 0)) {
                  _context84.next = 32;
                  break;
                }

                throw new Error("Decryption failed");

              case 32:
                psEnd++;
                _context84.next = 26;
                break;

              case 35:
                if (!(psEnd === dataBlock.length)) {
                  _context84.next = 37;
                  break;
                }

                throw new Error("Decryption failed");

              case 37:
                pkcs0 = dataBlock.subarray(psEnd + 1);
                return _context84.abrupt("return", new Uint8Array(pkcs0).buffer);

              case 39:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, this);
      }));

      function onDecrypt(_x267, _x268, _x269) {
        return _onDecrypt8.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(format, key) {
        return _regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                return _context85.abrupt("return", RsaCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85);
      }));

      function onExportKey(_x270, _x271) {
        return _onExportKey11.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                _context86.next = 2;
                return RsaCrypto.importKey(format, keyData, _objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                key = _context86.sent;
                return _context86.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, this);
      }));

      function onImportKey(_x272, _x273, _x274, _x275, _x276) {
        return _onImportKey11.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(RsaOaepProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      var internalKey = getCryptoKey(key);

      if (!(internalKey instanceof RsaPrivateKey || internalKey instanceof RsaPublicKey)) {
        throw new TypeError("key: Is not RSA CryptoKey");
      }
    }
  }, {
    key: "mgf1",
    value: function mgf1(algorithm, seed) {
      var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var hashSize = ShaCrypto.size(algorithm) >> 3;
      var mask = new Uint8Array(length);
      var counter = new Uint8Array(4);
      var chunks = Math.ceil(length / hashSize);

      for (var i = 0; i < chunks; i++) {
        counter[0] = i >>> 24;
        counter[1] = i >>> 16 & 255;
        counter[2] = i >>> 8 & 255;
        counter[3] = i & 255;
        var submask = mask.subarray(i * hashSize);
        var chunk = crypto__default.createHash(algorithm.name.replace("-", "")).update(seed).update(counter).digest();

        if (chunk.length > submask.length) {
          chunk = chunk.subarray(0, submask.length);
        }

        submask.set(chunk);
      }

      return mask;
    }
  }]);

  return RsaOaepProvider;
}(core.RsaOaepProvider);

var RsaEsProvider = /*#__PURE__*/function (_core$ProviderCrypto) {
  _inherits(RsaEsProvider, _core$ProviderCrypto);

  var _super19 = _createSuper(RsaEsProvider);

  function RsaEsProvider() {
    var _this10;

    _classCallCheck(this, RsaEsProvider);

    _this10 = _super19.apply(this, arguments);
    _this10.name = "RSAES-PKCS1-v1_5";
    _this10.usages = {
      publicKey: ["encrypt", "wrapKey"],
      privateKey: ["decrypt", "unwrapKey"]
    };
    return _this10;
  }

  _createClass(RsaEsProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(algorithm, extractable, keyUsages) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                _context87.next = 2;
                return RsaCrypto.generateKey(_objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                keys = _context87.sent;
                return _context87.abrupt("return", {
                  privateKey: setCryptoKey(keys.privateKey),
                  publicKey: setCryptoKey(keys.publicKey)
                });

              case 4:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, this);
      }));

      function onGenerateKey(_x277, _x278, _x279) {
        return _onGenerateKey12.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "checkGenerateKeyParams",
    value: function checkGenerateKeyParams(algorithm) {
      this.checkRequiredProperty(algorithm, "publicExponent");

      if (!(algorithm.publicExponent && algorithm.publicExponent instanceof Uint8Array)) {
        throw new TypeError("publicExponent: Missing or not a Uint8Array");
      }

      var publicExponent = Convert.ToBase64(algorithm.publicExponent);

      if (!(publicExponent === "Aw==" || publicExponent === "AQAB")) {
        throw new TypeError("publicExponent: Must be [3] or [1,0,1]");
      }

      this.checkRequiredProperty(algorithm, "modulusLength");

      switch (algorithm.modulusLength) {
        case 1024:
        case 2048:
        case 4096:
          break;

        default:
          throw new TypeError("modulusLength: Must be 1024, 2048, or 4096");
      }
    }
  }, {
    key: "onEncrypt",
    value: function () {
      var _onEncrypt9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(algorithm, key, data) {
        var options, enc;
        return _regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                options = this.toCryptoOptions(key);
                enc = crypto.publicEncrypt(options, new Uint8Array(data));
                return _context88.abrupt("return", new Uint8Array(enc).buffer);

              case 3:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, this);
      }));

      function onEncrypt(_x280, _x281, _x282) {
        return _onEncrypt9.apply(this, arguments);
      }

      return onEncrypt;
    }()
  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(algorithm, key, data) {
        var options, dec;
        return _regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                options = this.toCryptoOptions(key);
                dec = crypto.privateDecrypt(options, new Uint8Array(data));
                return _context89.abrupt("return", new Uint8Array(dec).buffer);

              case 3:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this);
      }));

      function onDecrypt(_x283, _x284, _x285) {
        return _onDecrypt9.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90(format, key) {
        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                return _context90.abrupt("return", RsaCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90);
      }));

      function onExportKey(_x286, _x287) {
        return _onExportKey12.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                _context91.next = 2;
                return RsaCrypto.importKey(format, keyData, _objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                key = _context91.sent;
                return _context91.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));

      function onImportKey(_x288, _x289, _x290, _x291, _x292) {
        return _onImportKey12.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(RsaEsProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      var internalKey = getCryptoKey(key);

      if (!(internalKey instanceof RsaPrivateKey || internalKey instanceof RsaPublicKey)) {
        throw new TypeError("key: Is not RSA CryptoKey");
      }
    }
  }, {
    key: "toCryptoOptions",
    value: function toCryptoOptions(key) {
      var type = key.type.toUpperCase();
      return {
        key: "-----BEGIN ".concat(type, " KEY-----\n").concat(getCryptoKey(key).data.toString("base64"), "\n-----END ").concat(type, " KEY-----"),
        padding: crypto.constants.RSA_PKCS1_PADDING
      };
    }
  }]);

  return RsaEsProvider;
}(core.ProviderCrypto);

var namedOIDs = {
  "1.2.840.10045.3.1.7": "P-256",
  "P-256": "1.2.840.10045.3.1.7",
  "1.3.132.0.34": "P-384",
  "P-384": "1.3.132.0.34",
  "1.3.132.0.35": "P-521",
  "P-521": "1.3.132.0.35",
  "1.3.132.0.10": "K-256",
  "K-256": "1.3.132.0.10",
  "brainpoolP160r1": "1.3.36.3.3.2.8.1.1.1",
  "1.3.36.3.3.2.8.1.1.1": "brainpoolP160r1",
  "brainpoolP160t1": "1.3.36.3.3.2.8.1.1.2",
  "1.3.36.3.3.2.8.1.1.2": "brainpoolP160t1",
  "brainpoolP192r1": "1.3.36.3.3.2.8.1.1.3",
  "1.3.36.3.3.2.8.1.1.3": "brainpoolP192r1",
  "brainpoolP192t1": "1.3.36.3.3.2.8.1.1.4",
  "1.3.36.3.3.2.8.1.1.4": "brainpoolP192t1",
  "brainpoolP224r1": "1.3.36.3.3.2.8.1.1.5",
  "1.3.36.3.3.2.8.1.1.5": "brainpoolP224r1",
  "brainpoolP224t1": "1.3.36.3.3.2.8.1.1.6",
  "1.3.36.3.3.2.8.1.1.6": "brainpoolP224t1",
  "brainpoolP256r1": "1.3.36.3.3.2.8.1.1.7",
  "1.3.36.3.3.2.8.1.1.7": "brainpoolP256r1",
  "brainpoolP256t1": "1.3.36.3.3.2.8.1.1.8",
  "1.3.36.3.3.2.8.1.1.8": "brainpoolP256t1",
  "brainpoolP320r1": "1.3.36.3.3.2.8.1.1.9",
  "1.3.36.3.3.2.8.1.1.9": "brainpoolP320r1",
  "brainpoolP320t1": "1.3.36.3.3.2.8.1.1.10",
  "1.3.36.3.3.2.8.1.1.10": "brainpoolP320t1",
  "brainpoolP384r1": "1.3.36.3.3.2.8.1.1.11",
  "1.3.36.3.3.2.8.1.1.11": "brainpoolP384r1",
  "brainpoolP384t1": "1.3.36.3.3.2.8.1.1.12",
  "1.3.36.3.3.2.8.1.1.12": "brainpoolP384t1",
  "brainpoolP512r1": "1.3.36.3.3.2.8.1.1.13",
  "1.3.36.3.3.2.8.1.1.13": "brainpoolP512r1",
  "brainpoolP512t1": "1.3.36.3.3.2.8.1.1.14",
  "1.3.36.3.3.2.8.1.1.14": "brainpoolP512t1"
};

function getOidByNamedCurve$1(namedCurve) {
  var oid = namedOIDs[namedCurve];

  if (!oid) {
    throw new core.OperationError("Cannot convert WebCrypto named curve '".concat(namedCurve, "' to OID"));
  }

  return oid;
}

var EcPrivateKey = /*#__PURE__*/function (_AsymmetricKey3) {
  _inherits(EcPrivateKey, _AsymmetricKey3);

  var _super20 = _createSuper(EcPrivateKey);

  function EcPrivateKey() {
    var _this11;

    _classCallCheck(this, EcPrivateKey);

    _this11 = _super20.apply(this, arguments);
    _this11.type = "private";
    return _this11;
  }

  _createClass(EcPrivateKey, [{
    key: "getKey",
    value: function getKey() {
      var keyInfo = AsnParser.parse(this.data, core.asn1.PrivateKeyInfo);
      return AsnParser.parse(keyInfo.privateKey, core.asn1.EcPrivateKey);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var key = this.getKey();
      var json = {
        kty: "EC",
        crv: this.algorithm.namedCurve,
        key_ops: this.usages,
        ext: this.extractable
      };
      return Object.assign(json, JsonSerializer.toJSON(key));
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (!json.crv) {
        throw new core.OperationError("Cannot get named curve from JWK. Property 'crv' is required");
      }

      var keyInfo = new core.asn1.PrivateKeyInfo();
      keyInfo.privateKeyAlgorithm.algorithm = "1.2.840.10045.2.1";
      keyInfo.privateKeyAlgorithm.parameters = AsnSerializer.serialize(new core.asn1.ObjectIdentifier(getOidByNamedCurve$1(json.crv)));
      var key = JsonParser.fromJSON(json, {
        targetSchema: core.asn1.EcPrivateKey
      });
      keyInfo.privateKey = AsnSerializer.serialize(key);
      this.data = Buffer.from(AsnSerializer.serialize(keyInfo));
      return this;
    }
  }]);

  return EcPrivateKey;
}(AsymmetricKey);

var EcPublicKey = /*#__PURE__*/function (_AsymmetricKey4) {
  _inherits(EcPublicKey, _AsymmetricKey4);

  var _super21 = _createSuper(EcPublicKey);

  function EcPublicKey() {
    var _this12;

    _classCallCheck(this, EcPublicKey);

    _this12 = _super21.apply(this, arguments);
    _this12.type = "public";
    return _this12;
  }

  _createClass(EcPublicKey, [{
    key: "getKey",
    value: function getKey() {
      var keyInfo = AsnParser.parse(this.data, core.asn1.PublicKeyInfo);
      return new core.asn1.EcPublicKey(keyInfo.publicKey);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var key = this.getKey();
      var json = {
        kty: "EC",
        crv: this.algorithm.namedCurve,
        key_ops: this.usages,
        ext: this.extractable
      };
      return Object.assign(json, JsonSerializer.toJSON(key));
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (!json.crv) {
        throw new core.OperationError("Cannot get named curve from JWK. Property 'crv' is required");
      }

      var key = JsonParser.fromJSON(json, {
        targetSchema: core.asn1.EcPublicKey
      });
      var keyInfo = new core.asn1.PublicKeyInfo();
      keyInfo.publicKeyAlgorithm.algorithm = "1.2.840.10045.2.1";
      keyInfo.publicKeyAlgorithm.parameters = AsnSerializer.serialize(new core.asn1.ObjectIdentifier(getOidByNamedCurve$1(json.crv)));
      keyInfo.publicKey = AsnSerializer.toASN(key).valueHex;
      this.data = Buffer.from(AsnSerializer.serialize(keyInfo));
      return this;
    }
  }]);

  return EcPublicKey;
}(AsymmetricKey);

var Sha1Provider = /*#__PURE__*/function (_core$ProviderCrypto2) {
  _inherits(Sha1Provider, _core$ProviderCrypto2);

  var _super22 = _createSuper(Sha1Provider);

  function Sha1Provider() {
    var _this13;

    _classCallCheck(this, Sha1Provider);

    _this13 = _super22.apply(this, arguments);
    _this13.name = "SHA-1";
    _this13.usages = [];
    return _this13;
  }

  _createClass(Sha1Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                return _context92.abrupt("return", ShaCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92);
      }));

      function onDigest(_x293, _x294) {
        return _onDigest.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Sha1Provider;
}(core.ProviderCrypto);

var Sha256Provider = /*#__PURE__*/function (_core$ProviderCrypto3) {
  _inherits(Sha256Provider, _core$ProviderCrypto3);

  var _super23 = _createSuper(Sha256Provider);

  function Sha256Provider() {
    var _this14;

    _classCallCheck(this, Sha256Provider);

    _this14 = _super23.apply(this, arguments);
    _this14.name = "SHA-256";
    _this14.usages = [];
    return _this14;
  }

  _createClass(Sha256Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                return _context93.abrupt("return", ShaCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93);
      }));

      function onDigest(_x295, _x296) {
        return _onDigest2.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Sha256Provider;
}(core.ProviderCrypto);

var Sha384Provider = /*#__PURE__*/function (_core$ProviderCrypto4) {
  _inherits(Sha384Provider, _core$ProviderCrypto4);

  var _super24 = _createSuper(Sha384Provider);

  function Sha384Provider() {
    var _this15;

    _classCallCheck(this, Sha384Provider);

    _this15 = _super24.apply(this, arguments);
    _this15.name = "SHA-384";
    _this15.usages = [];
    return _this15;
  }

  _createClass(Sha384Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                return _context94.abrupt("return", ShaCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94);
      }));

      function onDigest(_x297, _x298) {
        return _onDigest3.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Sha384Provider;
}(core.ProviderCrypto);

var Sha512Provider = /*#__PURE__*/function (_core$ProviderCrypto5) {
  _inherits(Sha512Provider, _core$ProviderCrypto5);

  var _super25 = _createSuper(Sha512Provider);

  function Sha512Provider() {
    var _this16;

    _classCallCheck(this, Sha512Provider);

    _this16 = _super25.apply(this, arguments);
    _this16.name = "SHA-512";
    _this16.usages = [];
    return _this16;
  }

  _createClass(Sha512Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                return _context95.abrupt("return", ShaCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95);
      }));

      function onDigest(_x299, _x300) {
        return _onDigest4.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Sha512Provider;
}(core.ProviderCrypto);

var Sha3256Provider = /*#__PURE__*/function (_core$ProviderCrypto6) {
  _inherits(Sha3256Provider, _core$ProviderCrypto6);

  var _super26 = _createSuper(Sha3256Provider);

  function Sha3256Provider() {
    var _this17;

    _classCallCheck(this, Sha3256Provider);

    _this17 = _super26.apply(this, arguments);
    _this17.name = "SHA3-256";
    _this17.usages = [];
    return _this17;
  }

  _createClass(Sha3256Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                return _context96.abrupt("return", ShaCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96);
      }));

      function onDigest(_x301, _x302) {
        return _onDigest5.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Sha3256Provider;
}(core.ProviderCrypto);

var Sha3384Provider = /*#__PURE__*/function (_core$ProviderCrypto7) {
  _inherits(Sha3384Provider, _core$ProviderCrypto7);

  var _super27 = _createSuper(Sha3384Provider);

  function Sha3384Provider() {
    var _this18;

    _classCallCheck(this, Sha3384Provider);

    _this18 = _super27.apply(this, arguments);
    _this18.name = "SHA3-384";
    _this18.usages = [];
    return _this18;
  }

  _createClass(Sha3384Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                return _context97.abrupt("return", ShaCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97);
      }));

      function onDigest(_x303, _x304) {
        return _onDigest6.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Sha3384Provider;
}(core.ProviderCrypto);

var Sha3512Provider = /*#__PURE__*/function (_core$ProviderCrypto8) {
  _inherits(Sha3512Provider, _core$ProviderCrypto8);

  var _super28 = _createSuper(Sha3512Provider);

  function Sha3512Provider() {
    var _this19;

    _classCallCheck(this, Sha3512Provider);

    _this19 = _super28.apply(this, arguments);
    _this19.name = "SHA3-512";
    _this19.usages = [];
    return _this19;
  }

  _createClass(Sha3512Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                return _context98.abrupt("return", ShaCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98);
      }));

      function onDigest(_x305, _x306) {
        return _onDigest7.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Sha3512Provider;
}(core.ProviderCrypto);

var EcCrypto = /*#__PURE__*/function () {
  function EcCrypto() {
    _classCallCheck(this, EcCrypto);
  }

  _createClass(EcCrypto, null, [{
    key: "generateKey",
    value: function () {
      var _generateKey4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99(algorithm, extractable, keyUsages) {
        var _this20 = this;

        var privateKey, publicKey, keys, res;
        return _regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                privateKey = new EcPrivateKey();
                privateKey.algorithm = algorithm;
                privateKey.extractable = extractable;
                privateKey.usages = keyUsages.filter(function (usage) {
                  return _this20.privateKeyUsages.indexOf(usage) !== -1;
                });
                publicKey = new EcPublicKey();
                publicKey.algorithm = algorithm;
                publicKey.extractable = true;
                publicKey.usages = keyUsages.filter(function (usage) {
                  return _this20.publicKeyUsages.indexOf(usage) !== -1;
                });
                keys = crypto__default.generateKeyPairSync("ec", {
                  namedCurve: this.getOpenSSLNamedCurve(algorithm.namedCurve),
                  publicKeyEncoding: {
                    format: "der",
                    type: "spki"
                  },
                  privateKeyEncoding: {
                    format: "der",
                    type: "pkcs8"
                  }
                });
                privateKey.data = keys.privateKey;
                publicKey.data = keys.publicKey;
                res = {
                  privateKey: privateKey,
                  publicKey: publicKey
                };
                return _context99.abrupt("return", res);

              case 13:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, this);
      }));

      function generateKey(_x307, _x308, _x309) {
        return _generateKey4.apply(this, arguments);
      }

      return generateKey;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(algorithm, key, data) {
        var cryptoAlg, signer, options, signature, ecSignature, signatureRaw;
        return _regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                cryptoAlg = ShaCrypto.getAlgorithmName(algorithm.hash);
                signer = crypto__default.createSign(cryptoAlg);
                signer.update(Buffer.from(data));

                if (!key.pem) {
                  key.pem = "-----BEGIN PRIVATE KEY-----\n".concat(key.data.toString("base64"), "\n-----END PRIVATE KEY-----");
                }

                options = {
                  key: key.pem
                };
                signature = signer.sign(options);
                ecSignature = AsnParser.parse(signature, core.asn1.EcDsaSignature);
                signatureRaw = core.EcUtils.encodeSignature(ecSignature, core.EcCurves.get(key.algorithm.namedCurve).size);
                return _context100.abrupt("return", signatureRaw.buffer);

              case 9:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100);
      }));

      function sign(_x310, _x311, _x312) {
        return _sign2.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(algorithm, key, signature, data) {
        var cryptoAlg, signer, options, ecSignature, namedCurve, signaturePoint, ecSignatureRaw, ok;
        return _regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                cryptoAlg = ShaCrypto.getAlgorithmName(algorithm.hash);
                signer = crypto__default.createVerify(cryptoAlg);
                signer.update(Buffer.from(data));

                if (!key.pem) {
                  key.pem = "-----BEGIN PUBLIC KEY-----\n".concat(key.data.toString("base64"), "\n-----END PUBLIC KEY-----");
                }

                options = {
                  key: key.pem
                };
                ecSignature = new core.asn1.EcDsaSignature();
                namedCurve = core.EcCurves.get(key.algorithm.namedCurve);
                signaturePoint = core.EcUtils.decodeSignature(signature, namedCurve.size);
                ecSignature.r = BufferSourceConverter.toArrayBuffer(signaturePoint.r);
                ecSignature.s = BufferSourceConverter.toArrayBuffer(signaturePoint.s);
                ecSignatureRaw = Buffer.from(AsnSerializer.serialize(ecSignature));
                ok = signer.verify(options, ecSignatureRaw);
                return _context101.abrupt("return", ok);

              case 13:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101);
      }));

      function verify(_x313, _x314, _x315, _x316) {
        return _verify2.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "deriveBits",
    value: function () {
      var _deriveBits = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102(algorithm, baseKey, length) {
        var cryptoAlg, ecdh, asnPrivateKey, asnEcPrivateKey, asnPublicKey, bits;
        return _regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                cryptoAlg = this.getOpenSSLNamedCurve(baseKey.algorithm.namedCurve);
                ecdh = crypto__default.createECDH(cryptoAlg);
                asnPrivateKey = AsnParser.parse(baseKey.data, core.asn1.PrivateKeyInfo);
                asnEcPrivateKey = AsnParser.parse(asnPrivateKey.privateKey, core.asn1.EcPrivateKey);
                ecdh.setPrivateKey(Buffer.from(asnEcPrivateKey.privateKey));
                asnPublicKey = AsnParser.parse(algorithm.public.data, core.asn1.PublicKeyInfo);
                bits = ecdh.computeSecret(Buffer.from(asnPublicKey.publicKey));

                if (!(length === null)) {
                  _context102.next = 9;
                  break;
                }

                return _context102.abrupt("return", bits);

              case 9:
                return _context102.abrupt("return", new Uint8Array(bits).buffer.slice(0, length >> 3));

              case 10:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, this);
      }));

      function deriveBits(_x317, _x318, _x319) {
        return _deriveBits.apply(this, arguments);
      }

      return deriveBits;
    }()
  }, {
    key: "exportKey",
    value: function () {
      var _exportKey4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(format, key) {
        var publicKeyInfo;
        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                _context103.t0 = format.toLowerCase();
                _context103.next = _context103.t0 === "jwk" ? 3 : _context103.t0 === "pkcs8" ? 4 : _context103.t0 === "spki" ? 4 : _context103.t0 === "raw" ? 5 : 7;
                break;

              case 3:
                return _context103.abrupt("return", JsonSerializer.toJSON(key));

              case 4:
                return _context103.abrupt("return", new Uint8Array(key.data).buffer);

              case 5:
                publicKeyInfo = AsnParser.parse(key.data, core.asn1.PublicKeyInfo);
                return _context103.abrupt("return", publicKeyInfo.publicKey);

              case 7:
                throw new core.OperationError("format: Must be 'jwk', 'raw', pkcs8' or 'spki'");

              case 8:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103);
      }));

      function exportKey(_x320, _x321) {
        return _exportKey4.apply(this, arguments);
      }

      return exportKey;
    }()
  }, {
    key: "importKey",
    value: function () {
      var _importKey4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(format, keyData, algorithm, extractable, keyUsages) {
        var jwk, asnKey, _asnKey4, _asnKey5, keyInfo, _asnKey6, _keyInfo2, _asnKey7;

        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _context104.t0 = format.toLowerCase();
                _context104.next = _context104.t0 === "jwk" ? 3 : _context104.t0 === "raw" ? 11 : _context104.t0 === "spki" ? 13 : _context104.t0 === "pkcs8" ? 17 : 21;
                break;

              case 3:
                jwk = keyData;

                if (!jwk.d) {
                  _context104.next = 9;
                  break;
                }

                asnKey = JsonParser.fromJSON(keyData, {
                  targetSchema: core.asn1.EcPrivateKey
                });
                return _context104.abrupt("return", this.importPrivateKey(asnKey, algorithm, extractable, keyUsages));

              case 9:
                _asnKey4 = JsonParser.fromJSON(keyData, {
                  targetSchema: core.asn1.EcPublicKey
                });
                return _context104.abrupt("return", this.importPublicKey(_asnKey4, algorithm, extractable, keyUsages));

              case 11:
                _asnKey5 = new core.asn1.EcPublicKey(keyData);
                return _context104.abrupt("return", this.importPublicKey(_asnKey5, algorithm, extractable, keyUsages));

              case 13:
                keyInfo = AsnParser.parse(new Uint8Array(keyData), core.asn1.PublicKeyInfo);
                _asnKey6 = new core.asn1.EcPublicKey(keyInfo.publicKey);
                this.assertKeyParameters(keyInfo.publicKeyAlgorithm.parameters, algorithm.namedCurve);
                return _context104.abrupt("return", this.importPublicKey(_asnKey6, algorithm, extractable, keyUsages));

              case 17:
                _keyInfo2 = AsnParser.parse(new Uint8Array(keyData), core.asn1.PrivateKeyInfo);
                _asnKey7 = AsnParser.parse(_keyInfo2.privateKey, core.asn1.EcPrivateKey);
                this.assertKeyParameters(_keyInfo2.privateKeyAlgorithm.parameters, algorithm.namedCurve);
                return _context104.abrupt("return", this.importPrivateKey(_asnKey7, algorithm, extractable, keyUsages));

              case 21:
                throw new core.OperationError("format: Must be 'jwk', 'raw', 'pkcs8' or 'spki'");

              case 22:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this);
      }));

      function importKey(_x322, _x323, _x324, _x325, _x326) {
        return _importKey4.apply(this, arguments);
      }

      return importKey;
    }()
  }, {
    key: "assertKeyParameters",
    value: function assertKeyParameters(parameters, namedCurve) {
      if (!parameters) {
        throw new core.CryptoError("Key info doesn't have required parameters");
      }

      var namedCurveIdentifier = "";

      try {
        namedCurveIdentifier = AsnParser.parse(parameters, core.asn1.ObjectIdentifier).value;
      } catch (e) {
        throw new core.CryptoError("Cannot read key info parameters");
      }

      if (getOidByNamedCurve$1(namedCurve) !== namedCurveIdentifier) {
        throw new core.CryptoError("Key info parameter doesn't match to named curve");
      }
    }
  }, {
    key: "importPrivateKey",
    value: function () {
      var _importPrivateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(asnKey, algorithm, extractable, keyUsages) {
        var keyInfo, key;
        return _regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                keyInfo = new core.asn1.PrivateKeyInfo();
                keyInfo.privateKeyAlgorithm.algorithm = "1.2.840.10045.2.1";
                keyInfo.privateKeyAlgorithm.parameters = AsnSerializer.serialize(new core.asn1.ObjectIdentifier(getOidByNamedCurve$1(algorithm.namedCurve)));
                keyInfo.privateKey = AsnSerializer.serialize(asnKey);
                key = new EcPrivateKey();
                key.data = Buffer.from(AsnSerializer.serialize(keyInfo));
                key.algorithm = Object.assign({}, algorithm);
                key.extractable = extractable;
                key.usages = keyUsages;
                return _context105.abrupt("return", key);

              case 10:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105);
      }));

      function importPrivateKey(_x327, _x328, _x329, _x330) {
        return _importPrivateKey.apply(this, arguments);
      }

      return importPrivateKey;
    }()
  }, {
    key: "importPublicKey",
    value: function () {
      var _importPublicKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(asnKey, algorithm, extractable, keyUsages) {
        var keyInfo, namedCurve, key;
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                keyInfo = new core.asn1.PublicKeyInfo();
                keyInfo.publicKeyAlgorithm.algorithm = "1.2.840.10045.2.1";
                namedCurve = getOidByNamedCurve$1(algorithm.namedCurve);
                keyInfo.publicKeyAlgorithm.parameters = AsnSerializer.serialize(new core.asn1.ObjectIdentifier(namedCurve));
                keyInfo.publicKey = asnKey.value;
                key = new EcPublicKey();
                key.data = Buffer.from(AsnSerializer.serialize(keyInfo));
                key.algorithm = Object.assign({}, algorithm);
                key.extractable = extractable;
                key.usages = keyUsages;
                return _context106.abrupt("return", key);

              case 11:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106);
      }));

      function importPublicKey(_x331, _x332, _x333, _x334) {
        return _importPublicKey.apply(this, arguments);
      }

      return importPublicKey;
    }()
  }, {
    key: "getOpenSSLNamedCurve",
    value: function getOpenSSLNamedCurve(curve) {
      switch (curve.toUpperCase()) {
        case "P-256":
          return "prime256v1";

        case "K-256":
          return "secp256k1";

        case "P-384":
          return "secp384r1";

        case "P-521":
          return "secp521r1";

        default:
          return curve;
      }
    }
  }]);

  return EcCrypto;
}();

EcCrypto.publicKeyUsages = ["verify"];
EcCrypto.privateKeyUsages = ["sign", "deriveKey", "deriveBits"];

var EcdsaProvider = /*#__PURE__*/function (_core$EcdsaProvider) {
  _inherits(EcdsaProvider, _core$EcdsaProvider);

  var _super29 = _createSuper(EcdsaProvider);

  function EcdsaProvider() {
    var _this21;

    _classCallCheck(this, EcdsaProvider);

    _this21 = _super29.apply(this, arguments);
    _this21.namedCurves = core.EcCurves.names;
    _this21.hashAlgorithms = ["SHA-1", "SHA-256", "SHA-384", "SHA-512", "shake128", "shake256", "SHA3-256", "SHA3-384", "SHA3-512"];
    return _this21;
  }

  _createClass(EcdsaProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(algorithm, extractable, keyUsages) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                _context107.next = 2;
                return EcCrypto.generateKey(_objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                keys = _context107.sent;
                return _context107.abrupt("return", {
                  privateKey: setCryptoKey(keys.privateKey),
                  publicKey: setCryptoKey(keys.publicKey)
                });

              case 4:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this);
      }));

      function onGenerateKey(_x335, _x336, _x337) {
        return _onGenerateKey13.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onSign",
    value: function () {
      var _onSign4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                return _context108.abrupt("return", EcCrypto.sign(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108);
      }));

      function onSign(_x338, _x339, _x340) {
        return _onSign4.apply(this, arguments);
      }

      return onSign;
    }()
  }, {
    key: "onVerify",
    value: function () {
      var _onVerify4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109(algorithm, key, signature, data) {
        return _regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                return _context109.abrupt("return", EcCrypto.verify(algorithm, getCryptoKey(key), new Uint8Array(signature), new Uint8Array(data)));

              case 1:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109);
      }));

      function onVerify(_x341, _x342, _x343, _x344) {
        return _onVerify4.apply(this, arguments);
      }

      return onVerify;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110(format, key) {
        return _regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                return _context110.abrupt("return", EcCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110);
      }));

      function onExportKey(_x345, _x346) {
        return _onExportKey13.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                _context111.next = 2;
                return EcCrypto.importKey(format, keyData, _objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                key = _context111.sent;
                return _context111.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));

      function onImportKey(_x347, _x348, _x349, _x350, _x351) {
        return _onImportKey13.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(EcdsaProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      var internalKey = getCryptoKey(key);

      if (!(internalKey instanceof EcPrivateKey || internalKey instanceof EcPublicKey)) {
        throw new TypeError("key: Is not EC CryptoKey");
      }
    }
  }]);

  return EcdsaProvider;
}(core.EcdsaProvider);

var EcdhProvider = /*#__PURE__*/function (_core$EcdhProvider) {
  _inherits(EcdhProvider, _core$EcdhProvider);

  var _super30 = _createSuper(EcdhProvider);

  function EcdhProvider() {
    var _this22;

    _classCallCheck(this, EcdhProvider);

    _this22 = _super30.apply(this, arguments);
    _this22.namedCurves = core.EcCurves.names;
    return _this22;
  }

  _createClass(EcdhProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112(algorithm, extractable, keyUsages) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                _context112.next = 2;
                return EcCrypto.generateKey(_objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                keys = _context112.sent;
                return _context112.abrupt("return", {
                  privateKey: setCryptoKey(keys.privateKey),
                  publicKey: setCryptoKey(keys.publicKey)
                });

              case 4:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this);
      }));

      function onGenerateKey(_x352, _x353, _x354) {
        return _onGenerateKey14.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113(format, key) {
        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                return _context113.abrupt("return", EcCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113);
      }));

      function onExportKey(_x355, _x356) {
        return _onExportKey14.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee114(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                _context114.next = 2;
                return EcCrypto.importKey(format, keyData, _objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                key = _context114.sent;
                return _context114.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114, this);
      }));

      function onImportKey(_x357, _x358, _x359, _x360, _x361) {
        return _onImportKey14.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(EcdhProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      var internalKey = getCryptoKey(key);

      if (!(internalKey instanceof EcPrivateKey || internalKey instanceof EcPublicKey)) {
        throw new TypeError("key: Is not EC CryptoKey");
      }
    }
  }, {
    key: "onDeriveBits",
    value: function () {
      var _onDeriveBits = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee115(algorithm, baseKey, length) {
        var bits;
        return _regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                _context115.next = 2;
                return EcCrypto.deriveBits(_objectSpread(_objectSpread({}, algorithm), {}, {
                  public: getCryptoKey(algorithm.public)
                }), getCryptoKey(baseKey), length);

              case 2:
                bits = _context115.sent;
                return _context115.abrupt("return", bits);

              case 4:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115);
      }));

      function onDeriveBits(_x362, _x363, _x364) {
        return _onDeriveBits.apply(this, arguments);
      }

      return onDeriveBits;
    }()
  }]);

  return EcdhProvider;
}(core.EcdhProvider);

var edOIDs = (_edOIDs = {}, _defineProperty(_edOIDs, core.asn1.idEd448, "Ed448"), _defineProperty(_edOIDs, "ed448", core.asn1.idEd448), _defineProperty(_edOIDs, core.asn1.idX448, "X448"), _defineProperty(_edOIDs, "x448", core.asn1.idX448), _defineProperty(_edOIDs, core.asn1.idEd25519, "Ed25519"), _defineProperty(_edOIDs, "ed25519", core.asn1.idEd25519), _defineProperty(_edOIDs, core.asn1.idX25519, "X25519"), _defineProperty(_edOIDs, "x25519", core.asn1.idX25519), _edOIDs);

function getOidByNamedCurve(namedCurve) {
  var oid = edOIDs[namedCurve.toLowerCase()];

  if (!oid) {
    throw new core.OperationError("Cannot convert WebCrypto named curve '".concat(namedCurve, "' to OID"));
  }

  return oid;
}

var EdPrivateKey = /*#__PURE__*/function (_AsymmetricKey5) {
  _inherits(EdPrivateKey, _AsymmetricKey5);

  var _super31 = _createSuper(EdPrivateKey);

  function EdPrivateKey() {
    var _this23;

    _classCallCheck(this, EdPrivateKey);

    _this23 = _super31.apply(this, arguments);
    _this23.type = "private";
    return _this23;
  }

  _createClass(EdPrivateKey, [{
    key: "getKey",
    value: function getKey() {
      var keyInfo = AsnParser.parse(this.data, core.asn1.PrivateKeyInfo);
      return AsnParser.parse(keyInfo.privateKey, core.asn1.CurvePrivateKey);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var key = this.getKey();
      var json = {
        kty: "OKP",
        crv: this.algorithm.namedCurve,
        key_ops: this.usages,
        ext: this.extractable
      };
      return Object.assign(json, JsonSerializer.toJSON(key));
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (!json.crv) {
        throw new core.OperationError("Cannot get named curve from JWK. Property 'crv' is required");
      }

      var keyInfo = new core.asn1.PrivateKeyInfo();
      keyInfo.privateKeyAlgorithm.algorithm = getOidByNamedCurve(json.crv);
      var key = JsonParser.fromJSON(json, {
        targetSchema: core.asn1.CurvePrivateKey
      });
      keyInfo.privateKey = AsnSerializer.serialize(key);
      this.data = Buffer.from(AsnSerializer.serialize(keyInfo));
      return this;
    }
  }]);

  return EdPrivateKey;
}(AsymmetricKey);

var EdPublicKey = /*#__PURE__*/function (_AsymmetricKey6) {
  _inherits(EdPublicKey, _AsymmetricKey6);

  var _super32 = _createSuper(EdPublicKey);

  function EdPublicKey() {
    var _this24;

    _classCallCheck(this, EdPublicKey);

    _this24 = _super32.apply(this, arguments);
    _this24.type = "public";
    return _this24;
  }

  _createClass(EdPublicKey, [{
    key: "getKey",
    value: function getKey() {
      var keyInfo = AsnParser.parse(this.data, core.asn1.PublicKeyInfo);
      return keyInfo.publicKey;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var key = this.getKey();
      var json = {
        kty: "OKP",
        crv: this.algorithm.namedCurve,
        key_ops: this.usages,
        ext: this.extractable
      };
      return Object.assign(json, {
        x: Convert.ToBase64Url(key)
      });
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (!json.crv) {
        throw new core.OperationError("Cannot get named curve from JWK. Property 'crv' is required");
      }

      if (!json.x) {
        throw new core.OperationError("Cannot get property from JWK. Property 'x' is required");
      }

      var keyInfo = new core.asn1.PublicKeyInfo();
      keyInfo.publicKeyAlgorithm.algorithm = getOidByNamedCurve(json.crv);
      keyInfo.publicKey = Convert.FromBase64Url(json.x);
      this.data = Buffer.from(AsnSerializer.serialize(keyInfo));
      return this;
    }
  }]);

  return EdPublicKey;
}(AsymmetricKey);

var EdCrypto = /*#__PURE__*/function () {
  function EdCrypto() {
    _classCallCheck(this, EdCrypto);
  }

  _createClass(EdCrypto, null, [{
    key: "generateKey",
    value: function () {
      var _generateKey5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee116(algorithm, extractable, keyUsages) {
        var _this25 = this;

        var privateKey, publicKey, type, keys, res;
        return _regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                privateKey = new EdPrivateKey();
                privateKey.algorithm = algorithm;
                privateKey.extractable = extractable;
                privateKey.usages = keyUsages.filter(function (usage) {
                  return _this25.privateKeyUsages.indexOf(usage) !== -1;
                });
                publicKey = new EdPublicKey();
                publicKey.algorithm = algorithm;
                publicKey.extractable = true;
                publicKey.usages = keyUsages.filter(function (usage) {
                  return _this25.publicKeyUsages.indexOf(usage) !== -1;
                });
                type = algorithm.namedCurve.toLowerCase();
                keys = crypto__default.generateKeyPairSync(type, {
                  publicKeyEncoding: {
                    format: "der",
                    type: "spki"
                  },
                  privateKeyEncoding: {
                    format: "der",
                    type: "pkcs8"
                  }
                });
                privateKey.data = keys.privateKey;
                publicKey.data = keys.publicKey;
                res = {
                  privateKey: privateKey,
                  publicKey: publicKey
                };
                return _context116.abrupt("return", res);

              case 14:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116);
      }));

      function generateKey(_x365, _x366, _x367) {
        return _generateKey5.apply(this, arguments);
      }

      return generateKey;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee117(algorithm, key, data) {
        var options, signature;
        return _regeneratorRuntime.wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                if (!key.pem) {
                  key.pem = "-----BEGIN PRIVATE KEY-----\n".concat(key.data.toString("base64"), "\n-----END PRIVATE KEY-----");
                }

                options = {
                  key: key.pem
                };
                signature = crypto__default.sign(null, Buffer.from(data), options);
                return _context117.abrupt("return", core.BufferSourceConverter.toArrayBuffer(signature));

              case 4:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117);
      }));

      function sign(_x368, _x369, _x370) {
        return _sign3.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee118(algorithm, key, signature, data) {
        var options, ok;
        return _regeneratorRuntime.wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                if (!key.pem) {
                  key.pem = "-----BEGIN PUBLIC KEY-----\n".concat(key.data.toString("base64"), "\n-----END PUBLIC KEY-----");
                }

                options = {
                  key: key.pem
                };
                ok = crypto__default.verify(null, Buffer.from(data), options, Buffer.from(signature));
                return _context118.abrupt("return", ok);

              case 4:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118);
      }));

      function verify(_x371, _x372, _x373, _x374) {
        return _verify3.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "deriveBits",
    value: function () {
      var _deriveBits2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee119(algorithm, baseKey, length) {
        var publicKey, privateKey, bits;
        return _regeneratorRuntime.wrap(function _callee119$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                publicKey = crypto__default.createPublicKey({
                  key: algorithm.public.data,
                  format: "der",
                  type: "spki"
                });
                privateKey = crypto__default.createPrivateKey({
                  key: baseKey.data,
                  format: "der",
                  type: "pkcs8"
                });
                bits = crypto__default.diffieHellman({
                  publicKey: publicKey,
                  privateKey: privateKey
                });
                return _context119.abrupt("return", new Uint8Array(bits).buffer.slice(0, length >> 3));

              case 4:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee119);
      }));

      function deriveBits(_x375, _x376, _x377) {
        return _deriveBits2.apply(this, arguments);
      }

      return deriveBits;
    }()
  }, {
    key: "exportKey",
    value: function () {
      var _exportKey5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee120(format, key) {
        var publicKeyInfo;
        return _regeneratorRuntime.wrap(function _callee120$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                _context120.t0 = format.toLowerCase();
                _context120.next = _context120.t0 === "jwk" ? 3 : _context120.t0 === "pkcs8" ? 4 : _context120.t0 === "spki" ? 4 : _context120.t0 === "raw" ? 5 : 7;
                break;

              case 3:
                return _context120.abrupt("return", JsonSerializer.toJSON(key));

              case 4:
                return _context120.abrupt("return", new Uint8Array(key.data).buffer);

              case 5:
                publicKeyInfo = AsnParser.parse(key.data, core.asn1.PublicKeyInfo);
                return _context120.abrupt("return", publicKeyInfo.publicKey);

              case 7:
                throw new core.OperationError("format: Must be 'jwk', 'raw', pkcs8' or 'spki'");

              case 8:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee120);
      }));

      function exportKey(_x378, _x379) {
        return _exportKey5.apply(this, arguments);
      }

      return exportKey;
    }()
  }, {
    key: "importKey",
    value: function () {
      var _importKey5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee121(format, keyData, algorithm, extractable, keyUsages) {
        var jwk, asnKey, keyInfo, _keyInfo3, _asnKey8;

        return _regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                _context121.t0 = format.toLowerCase();
                _context121.next = _context121.t0 === "jwk" ? 3 : _context121.t0 === "raw" ? 12 : _context121.t0 === "spki" ? 13 : _context121.t0 === "pkcs8" ? 15 : 18;
                break;

              case 3:
                jwk = keyData;

                if (!jwk.d) {
                  _context121.next = 9;
                  break;
                }

                asnKey = JsonParser.fromJSON(keyData, {
                  targetSchema: core.asn1.CurvePrivateKey
                });
                return _context121.abrupt("return", this.importPrivateKey(asnKey, algorithm, extractable, keyUsages));

              case 9:
                if (jwk.x) {
                  _context121.next = 11;
                  break;
                }

                throw new TypeError("keyData: Cannot get required 'x' filed");

              case 11:
                return _context121.abrupt("return", this.importPublicKey(Convert.FromBase64Url(jwk.x), algorithm, extractable, keyUsages));

              case 12:
                return _context121.abrupt("return", this.importPublicKey(keyData, algorithm, extractable, keyUsages));

              case 13:
                keyInfo = AsnParser.parse(new Uint8Array(keyData), core.asn1.PublicKeyInfo);
                return _context121.abrupt("return", this.importPublicKey(keyInfo.publicKey, algorithm, extractable, keyUsages));

              case 15:
                _keyInfo3 = AsnParser.parse(new Uint8Array(keyData), core.asn1.PrivateKeyInfo);
                _asnKey8 = AsnParser.parse(_keyInfo3.privateKey, core.asn1.CurvePrivateKey);
                return _context121.abrupt("return", this.importPrivateKey(_asnKey8, algorithm, extractable, keyUsages));

              case 18:
                throw new core.OperationError("format: Must be 'jwk', 'raw', 'pkcs8' or 'spki'");

              case 19:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, this);
      }));

      function importKey(_x380, _x381, _x382, _x383, _x384) {
        return _importKey5.apply(this, arguments);
      }

      return importKey;
    }()
  }, {
    key: "importPrivateKey",
    value: function importPrivateKey(asnKey, algorithm, extractable, keyUsages) {
      var key = new EdPrivateKey();
      key.fromJSON({
        crv: algorithm.namedCurve,
        d: Convert.ToBase64Url(asnKey.d)
      });
      key.algorithm = Object.assign({}, algorithm);
      key.extractable = extractable;
      key.usages = keyUsages;
      return key;
    }
  }, {
    key: "importPublicKey",
    value: function () {
      var _importPublicKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee122(asnKey, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee122$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                key = new EdPublicKey();
                key.fromJSON({
                  crv: algorithm.namedCurve,
                  x: Convert.ToBase64Url(asnKey)
                });
                key.algorithm = Object.assign({}, algorithm);
                key.extractable = extractable;
                key.usages = keyUsages;
                return _context122.abrupt("return", key);

              case 6:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee122);
      }));

      function importPublicKey(_x385, _x386, _x387, _x388) {
        return _importPublicKey2.apply(this, arguments);
      }

      return importPublicKey;
    }()
  }]);

  return EdCrypto;
}();

EdCrypto.publicKeyUsages = ["verify"];
EdCrypto.privateKeyUsages = ["sign", "deriveKey", "deriveBits"];

var EdDsaProvider = /*#__PURE__*/function (_core$EdDsaProvider) {
  _inherits(EdDsaProvider, _core$EdDsaProvider);

  var _super33 = _createSuper(EdDsaProvider);

  function EdDsaProvider() {
    _classCallCheck(this, EdDsaProvider);

    return _super33.apply(this, arguments);
  }

  _createClass(EdDsaProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee123(algorithm, extractable, keyUsages) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee123$(_context123) {
          while (1) {
            switch (_context123.prev = _context123.next) {
              case 0:
                _context123.next = 2;
                return EdCrypto.generateKey({
                  name: this.name,
                  namedCurve: algorithm.namedCurve.replace(/^ed/i, "Ed")
                }, extractable, keyUsages);

              case 2:
                keys = _context123.sent;
                return _context123.abrupt("return", {
                  privateKey: setCryptoKey(keys.privateKey),
                  publicKey: setCryptoKey(keys.publicKey)
                });

              case 4:
              case "end":
                return _context123.stop();
            }
          }
        }, _callee123, this);
      }));

      function onGenerateKey(_x389, _x390, _x391) {
        return _onGenerateKey15.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onSign",
    value: function () {
      var _onSign5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee124(algorithm, key, data) {
        return _regeneratorRuntime.wrap(function _callee124$(_context124) {
          while (1) {
            switch (_context124.prev = _context124.next) {
              case 0:
                return _context124.abrupt("return", EdCrypto.sign(algorithm, getCryptoKey(key), new Uint8Array(data)));

              case 1:
              case "end":
                return _context124.stop();
            }
          }
        }, _callee124);
      }));

      function onSign(_x392, _x393, _x394) {
        return _onSign5.apply(this, arguments);
      }

      return onSign;
    }()
  }, {
    key: "onVerify",
    value: function () {
      var _onVerify5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee125(algorithm, key, signature, data) {
        return _regeneratorRuntime.wrap(function _callee125$(_context125) {
          while (1) {
            switch (_context125.prev = _context125.next) {
              case 0:
                return _context125.abrupt("return", EdCrypto.verify(algorithm, getCryptoKey(key), new Uint8Array(signature), new Uint8Array(data)));

              case 1:
              case "end":
                return _context125.stop();
            }
          }
        }, _callee125);
      }));

      function onVerify(_x395, _x396, _x397, _x398) {
        return _onVerify5.apply(this, arguments);
      }

      return onVerify;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee126(format, key) {
        return _regeneratorRuntime.wrap(function _callee126$(_context126) {
          while (1) {
            switch (_context126.prev = _context126.next) {
              case 0:
                return _context126.abrupt("return", EdCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context126.stop();
            }
          }
        }, _callee126);
      }));

      function onExportKey(_x399, _x400) {
        return _onExportKey15.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee127(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee127$(_context127) {
          while (1) {
            switch (_context127.prev = _context127.next) {
              case 0:
                _context127.next = 2;
                return EdCrypto.importKey(format, keyData, _objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                key = _context127.sent;
                return _context127.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context127.stop();
            }
          }
        }, _callee127, this);
      }));

      function onImportKey(_x401, _x402, _x403, _x404, _x405) {
        return _onImportKey15.apply(this, arguments);
      }

      return onImportKey;
    }()
  }]);

  return EdDsaProvider;
}(core.EdDsaProvider);

var EcdhEsProvider = /*#__PURE__*/function (_core$EcdhEsProvider) {
  _inherits(EcdhEsProvider, _core$EcdhEsProvider);

  var _super34 = _createSuper(EcdhEsProvider);

  function EcdhEsProvider() {
    _classCallCheck(this, EcdhEsProvider);

    return _super34.apply(this, arguments);
  }

  _createClass(EcdhEsProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee128(algorithm, extractable, keyUsages) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee128$(_context128) {
          while (1) {
            switch (_context128.prev = _context128.next) {
              case 0:
                _context128.next = 2;
                return EdCrypto.generateKey({
                  name: this.name,
                  namedCurve: algorithm.namedCurve.toUpperCase()
                }, extractable, keyUsages);

              case 2:
                keys = _context128.sent;
                return _context128.abrupt("return", {
                  privateKey: setCryptoKey(keys.privateKey),
                  publicKey: setCryptoKey(keys.publicKey)
                });

              case 4:
              case "end":
                return _context128.stop();
            }
          }
        }, _callee128, this);
      }));

      function onGenerateKey(_x406, _x407, _x408) {
        return _onGenerateKey16.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onDeriveBits",
    value: function () {
      var _onDeriveBits2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee129(algorithm, baseKey, length) {
        var bits;
        return _regeneratorRuntime.wrap(function _callee129$(_context129) {
          while (1) {
            switch (_context129.prev = _context129.next) {
              case 0:
                _context129.next = 2;
                return EdCrypto.deriveBits(_objectSpread(_objectSpread({}, algorithm), {}, {
                  public: getCryptoKey(algorithm.public)
                }), getCryptoKey(baseKey), length);

              case 2:
                bits = _context129.sent;
                return _context129.abrupt("return", bits);

              case 4:
              case "end":
                return _context129.stop();
            }
          }
        }, _callee129);
      }));

      function onDeriveBits(_x409, _x410, _x411) {
        return _onDeriveBits2.apply(this, arguments);
      }

      return onDeriveBits;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee130(format, key) {
        return _regeneratorRuntime.wrap(function _callee130$(_context130) {
          while (1) {
            switch (_context130.prev = _context130.next) {
              case 0:
                return _context130.abrupt("return", EdCrypto.exportKey(format, getCryptoKey(key)));

              case 1:
              case "end":
                return _context130.stop();
            }
          }
        }, _callee130);
      }));

      function onExportKey(_x412, _x413) {
        return _onExportKey16.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee131(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee131$(_context131) {
          while (1) {
            switch (_context131.prev = _context131.next) {
              case 0:
                _context131.next = 2;
                return EdCrypto.importKey(format, keyData, _objectSpread(_objectSpread({}, algorithm), {}, {
                  name: this.name
                }), extractable, keyUsages);

              case 2:
                key = _context131.sent;
                return _context131.abrupt("return", setCryptoKey(key));

              case 4:
              case "end":
                return _context131.stop();
            }
          }
        }, _callee131, this);
      }));

      function onImportKey(_x414, _x415, _x416, _x417, _x418) {
        return _onImportKey16.apply(this, arguments);
      }

      return onImportKey;
    }()
  }]);

  return EcdhEsProvider;
}(core.EcdhEsProvider);

var PbkdfCryptoKey = /*#__PURE__*/function (_CryptoKey3) {
  _inherits(PbkdfCryptoKey, _CryptoKey3);

  var _super35 = _createSuper(PbkdfCryptoKey);

  function PbkdfCryptoKey() {
    _classCallCheck(this, PbkdfCryptoKey);

    return _super35.apply(this, arguments);
  }

  return PbkdfCryptoKey;
}(CryptoKey);

var Pbkdf2Provider = /*#__PURE__*/function (_core$Pbkdf2Provider) {
  _inherits(Pbkdf2Provider, _core$Pbkdf2Provider);

  var _super36 = _createSuper(Pbkdf2Provider);

  function Pbkdf2Provider() {
    _classCallCheck(this, Pbkdf2Provider);

    return _super36.apply(this, arguments);
  }

  _createClass(Pbkdf2Provider, [{
    key: "onDeriveBits",
    value: function () {
      var _onDeriveBits3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee132(algorithm, baseKey, length) {
        return _regeneratorRuntime.wrap(function _callee132$(_context132) {
          while (1) {
            switch (_context132.prev = _context132.next) {
              case 0:
                return _context132.abrupt("return", new Promise(function (resolve, reject) {
                  var salt = core.BufferSourceConverter.toArrayBuffer(algorithm.salt);
                  var hash = algorithm.hash.name.replace("-", "");
                  crypto__default.pbkdf2(getCryptoKey(baseKey).data, Buffer.from(salt), algorithm.iterations, length >> 3, hash, function (err, derivedBits) {
                    if (err) {
                      reject(err);
                    } else {
                      resolve(new Uint8Array(derivedBits).buffer);
                    }
                  });
                }));

              case 1:
              case "end":
                return _context132.stop();
            }
          }
        }, _callee132);
      }));

      function onDeriveBits(_x419, _x420, _x421) {
        return _onDeriveBits3.apply(this, arguments);
      }

      return onDeriveBits;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee133(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee133$(_context133) {
          while (1) {
            switch (_context133.prev = _context133.next) {
              case 0:
                if (!(format === "raw")) {
                  _context133.next = 7;
                  break;
                }

                key = new PbkdfCryptoKey();
                key.data = Buffer.from(keyData);
                key.algorithm = {
                  name: this.name
                };
                key.extractable = false;
                key.usages = keyUsages;
                return _context133.abrupt("return", setCryptoKey(key));

              case 7:
                throw new core.OperationError("format: Must be 'raw'");

              case 8:
              case "end":
                return _context133.stop();
            }
          }
        }, _callee133, this);
      }));

      function onImportKey(_x422, _x423, _x424, _x425, _x426) {
        return _onImportKey17.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(Pbkdf2Provider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof PbkdfCryptoKey)) {
        throw new TypeError("key: Is not PBKDF CryptoKey");
      }
    }
  }]);

  return Pbkdf2Provider;
}(core.Pbkdf2Provider);

var HmacCryptoKey = /*#__PURE__*/function (_CryptoKey4) {
  _inherits(HmacCryptoKey, _CryptoKey4);

  var _super37 = _createSuper(HmacCryptoKey);

  function HmacCryptoKey() {
    _classCallCheck(this, HmacCryptoKey);

    return _super37.apply(this, arguments);
  }

  _createClass(HmacCryptoKey, [{
    key: "alg",
    get: function get() {
      var hash = this.algorithm.hash.name.toUpperCase();
      return "HS".concat(hash.replace("SHA-", ""));
    },
    set: function set(value) {}
  }]);

  return HmacCryptoKey;
}(CryptoKey);

__decorate([JsonProp({
  name: "k",
  converter: JsonBase64UrlConverter
})], HmacCryptoKey.prototype, "data", void 0);

var HmacProvider = /*#__PURE__*/function (_core$HmacProvider) {
  _inherits(HmacProvider, _core$HmacProvider);

  var _super38 = _createSuper(HmacProvider);

  function HmacProvider() {
    _classCallCheck(this, HmacProvider);

    return _super38.apply(this, arguments);
  }

  _createClass(HmacProvider, [{
    key: "onGenerateKey",
    value: function () {
      var _onGenerateKey17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee134(algorithm, extractable, keyUsages) {
        var length, key;
        return _regeneratorRuntime.wrap(function _callee134$(_context134) {
          while (1) {
            switch (_context134.prev = _context134.next) {
              case 0:
                length = (algorithm.length || this.getDefaultLength(algorithm.hash.name)) >> 3 << 3;
                key = new HmacCryptoKey();
                key.algorithm = _objectSpread(_objectSpread({}, algorithm), {}, {
                  length: length,
                  name: this.name
                });
                key.extractable = extractable;
                key.usages = keyUsages;
                key.data = crypto__default.randomBytes(length >> 3);
                return _context134.abrupt("return", setCryptoKey(key));

              case 7:
              case "end":
                return _context134.stop();
            }
          }
        }, _callee134, this);
      }));

      function onGenerateKey(_x427, _x428, _x429) {
        return _onGenerateKey17.apply(this, arguments);
      }

      return onGenerateKey;
    }()
  }, {
    key: "onSign",
    value: function () {
      var _onSign6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee135(algorithm, key, data) {
        var cryptoAlg, hmac;
        return _regeneratorRuntime.wrap(function _callee135$(_context135) {
          while (1) {
            switch (_context135.prev = _context135.next) {
              case 0:
                cryptoAlg = ShaCrypto.getAlgorithmName(key.algorithm.hash);
                hmac = crypto__default.createHmac(cryptoAlg, getCryptoKey(key).data).update(Buffer.from(data)).digest();
                return _context135.abrupt("return", new Uint8Array(hmac).buffer);

              case 3:
              case "end":
                return _context135.stop();
            }
          }
        }, _callee135);
      }));

      function onSign(_x430, _x431, _x432) {
        return _onSign6.apply(this, arguments);
      }

      return onSign;
    }()
  }, {
    key: "onVerify",
    value: function () {
      var _onVerify6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee136(algorithm, key, signature, data) {
        var cryptoAlg, hmac;
        return _regeneratorRuntime.wrap(function _callee136$(_context136) {
          while (1) {
            switch (_context136.prev = _context136.next) {
              case 0:
                cryptoAlg = ShaCrypto.getAlgorithmName(key.algorithm.hash);
                hmac = crypto__default.createHmac(cryptoAlg, getCryptoKey(key).data).update(Buffer.from(data)).digest();
                return _context136.abrupt("return", hmac.compare(Buffer.from(signature)) === 0);

              case 3:
              case "end":
                return _context136.stop();
            }
          }
        }, _callee136);
      }));

      function onVerify(_x433, _x434, _x435, _x436) {
        return _onVerify6.apply(this, arguments);
      }

      return onVerify;
    }()
  }, {
    key: "onImportKey",
    value: function () {
      var _onImportKey18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee137(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee137$(_context137) {
          while (1) {
            switch (_context137.prev = _context137.next) {
              case 0:
                _context137.t0 = format.toLowerCase();
                _context137.next = _context137.t0 === "jwk" ? 3 : _context137.t0 === "raw" ? 5 : 8;
                break;

              case 3:
                key = JsonParser.fromJSON(keyData, {
                  targetSchema: HmacCryptoKey
                });
                return _context137.abrupt("break", 9);

              case 5:
                key = new HmacCryptoKey();
                key.data = Buffer.from(keyData);
                return _context137.abrupt("break", 9);

              case 8:
                throw new core.OperationError("format: Must be 'jwk' or 'raw'");

              case 9:
                key.algorithm = {
                  hash: {
                    name: algorithm.hash.name
                  },
                  name: this.name,
                  length: key.data.length << 3
                };
                key.extractable = extractable;
                key.usages = keyUsages;
                return _context137.abrupt("return", setCryptoKey(key));

              case 13:
              case "end":
                return _context137.stop();
            }
          }
        }, _callee137, this);
      }));

      function onImportKey(_x437, _x438, _x439, _x440, _x441) {
        return _onImportKey18.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "onExportKey",
    value: function () {
      var _onExportKey17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee138(format, key) {
        return _regeneratorRuntime.wrap(function _callee138$(_context138) {
          while (1) {
            switch (_context138.prev = _context138.next) {
              case 0:
                _context138.t0 = format.toLowerCase();
                _context138.next = _context138.t0 === "jwk" ? 3 : _context138.t0 === "raw" ? 4 : 5;
                break;

              case 3:
                return _context138.abrupt("return", JsonSerializer.toJSON(getCryptoKey(key)));

              case 4:
                return _context138.abrupt("return", new Uint8Array(getCryptoKey(key).data).buffer);

              case 5:
                throw new core.OperationError("format: Must be 'jwk' or 'raw'");

              case 6:
              case "end":
                return _context138.stop();
            }
          }
        }, _callee138);
      }));

      function onExportKey(_x442, _x443) {
        return _onExportKey17.apply(this, arguments);
      }

      return onExportKey;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(HmacProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof HmacCryptoKey)) {
        throw new TypeError("key: Is not HMAC CryptoKey");
      }
    }
  }]);

  return HmacProvider;
}(core.HmacProvider);

var HkdfCryptoKey = /*#__PURE__*/function (_CryptoKey5) {
  _inherits(HkdfCryptoKey, _CryptoKey5);

  var _super39 = _createSuper(HkdfCryptoKey);

  function HkdfCryptoKey() {
    _classCallCheck(this, HkdfCryptoKey);

    return _super39.apply(this, arguments);
  }

  return HkdfCryptoKey;
}(CryptoKey);

var HkdfProvider = /*#__PURE__*/function (_core$HkdfProvider) {
  _inherits(HkdfProvider, _core$HkdfProvider);

  var _super40 = _createSuper(HkdfProvider);

  function HkdfProvider() {
    _classCallCheck(this, HkdfProvider);

    return _super40.apply(this, arguments);
  }

  _createClass(HkdfProvider, [{
    key: "onImportKey",
    value: function () {
      var _onImportKey19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee139(format, keyData, algorithm, extractable, keyUsages) {
        var key;
        return _regeneratorRuntime.wrap(function _callee139$(_context139) {
          while (1) {
            switch (_context139.prev = _context139.next) {
              case 0:
                if (!(format.toLowerCase() !== "raw")) {
                  _context139.next = 2;
                  break;
                }

                throw new core.OperationError("Operation not supported");

              case 2:
                key = new HkdfCryptoKey();
                key.data = Buffer.from(keyData);
                key.algorithm = {
                  name: this.name
                };
                key.extractable = extractable;
                key.usages = keyUsages;
                return _context139.abrupt("return", setCryptoKey(key));

              case 8:
              case "end":
                return _context139.stop();
            }
          }
        }, _callee139, this);
      }));

      function onImportKey(_x444, _x445, _x446, _x447, _x448) {
        return _onImportKey19.apply(this, arguments);
      }

      return onImportKey;
    }()
  }, {
    key: "onDeriveBits",
    value: function () {
      var _onDeriveBits4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee140(params, baseKey, length) {
        var hash, hashLength, byteLength, info, PRK, blocks, blockCount, i;
        return _regeneratorRuntime.wrap(function _callee140$(_context140) {
          while (1) {
            switch (_context140.prev = _context140.next) {
              case 0:
                hash = params.hash.name.replace("-", "");
                hashLength = crypto__default.createHash(hash).digest().length;
                byteLength = length / 8;
                info = BufferSourceConverter$1.toUint8Array(params.info);
                PRK = crypto__default.createHmac(hash, BufferSourceConverter$1.toUint8Array(params.salt)).update(BufferSourceConverter$1.toUint8Array(getCryptoKey(baseKey).data)).digest();
                blocks = [Buffer.alloc(0)];
                blockCount = Math.ceil(byteLength / hashLength) + 1;

                for (i = 1; i < blockCount; ++i) {
                  blocks.push(crypto__default.createHmac(hash, PRK).update(Buffer.concat([blocks[i - 1], info, Buffer.from([i])])).digest());
                }

                return _context140.abrupt("return", Buffer.concat(blocks).slice(0, byteLength));

              case 9:
              case "end":
                return _context140.stop();
            }
          }
        }, _callee140);
      }));

      function onDeriveBits(_x449, _x450, _x451) {
        return _onDeriveBits4.apply(this, arguments);
      }

      return onDeriveBits;
    }()
  }, {
    key: "checkCryptoKey",
    value: function checkCryptoKey(key, keyUsage) {
      _get(_getPrototypeOf(HkdfProvider.prototype), "checkCryptoKey", this).call(this, key, keyUsage);

      if (!(getCryptoKey(key) instanceof HkdfCryptoKey)) {
        throw new TypeError("key: Is not HKDF CryptoKey");
      }
    }
  }]);

  return HkdfProvider;
}(core.HkdfProvider);

var ShakeCrypto = /*#__PURE__*/function () {
  function ShakeCrypto() {
    _classCallCheck(this, ShakeCrypto);
  }

  _createClass(ShakeCrypto, null, [{
    key: "digest",
    value: function digest(algorithm, data) {
      var hash = crypto__default.createHash(algorithm.name.toLowerCase(), {
        outputLength: algorithm.length
      }).update(Buffer.from(data)).digest();
      return new Uint8Array(hash).buffer;
    }
  }]);

  return ShakeCrypto;
}();

var Shake128Provider = /*#__PURE__*/function (_core$Shake128Provide) {
  _inherits(Shake128Provider, _core$Shake128Provide);

  var _super41 = _createSuper(Shake128Provider);

  function Shake128Provider() {
    _classCallCheck(this, Shake128Provider);

    return _super41.apply(this, arguments);
  }

  _createClass(Shake128Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee141(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee141$(_context141) {
          while (1) {
            switch (_context141.prev = _context141.next) {
              case 0:
                return _context141.abrupt("return", ShakeCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context141.stop();
            }
          }
        }, _callee141);
      }));

      function onDigest(_x452, _x453) {
        return _onDigest8.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Shake128Provider;
}(core.Shake128Provider);

var Shake256Provider = /*#__PURE__*/function (_core$Shake256Provide) {
  _inherits(Shake256Provider, _core$Shake256Provide);

  var _super42 = _createSuper(Shake256Provider);

  function Shake256Provider() {
    _classCallCheck(this, Shake256Provider);

    return _super42.apply(this, arguments);
  }

  _createClass(Shake256Provider, [{
    key: "onDigest",
    value: function () {
      var _onDigest9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee142(algorithm, data) {
        return _regeneratorRuntime.wrap(function _callee142$(_context142) {
          while (1) {
            switch (_context142.prev = _context142.next) {
              case 0:
                return _context142.abrupt("return", ShakeCrypto.digest(algorithm, data));

              case 1:
              case "end":
                return _context142.stop();
            }
          }
        }, _callee142);
      }));

      function onDigest(_x454, _x455) {
        return _onDigest9.apply(this, arguments);
      }

      return onDigest;
    }()
  }]);

  return Shake256Provider;
}(core.Shake256Provider);

var SubtleCrypto = /*#__PURE__*/function (_core$SubtleCrypto) {
  _inherits(SubtleCrypto, _core$SubtleCrypto);

  var _super43 = _createSuper(SubtleCrypto);

  function SubtleCrypto() {
    var _this26;

    _classCallCheck(this, SubtleCrypto);

    var _a;

    _this26 = _super43.call(this);

    _this26.providers.set(new AesCbcProvider());

    _this26.providers.set(new AesCtrProvider());

    _this26.providers.set(new AesGcmProvider());

    _this26.providers.set(new AesCmacProvider());

    _this26.providers.set(new AesKwProvider());

    _this26.providers.set(new AesEcbProvider());

    var ciphers = crypto.getCiphers();

    if (ciphers.includes("des-cbc")) {
      _this26.providers.set(new DesCbcProvider());
    }

    _this26.providers.set(new DesEde3CbcProvider());

    _this26.providers.set(new RsaSsaProvider());

    _this26.providers.set(new RsaPssProvider());

    _this26.providers.set(new RsaOaepProvider());

    _this26.providers.set(new RsaEsProvider());

    _this26.providers.set(new EcdsaProvider());

    _this26.providers.set(new EcdhProvider());

    _this26.providers.set(new Sha1Provider());

    _this26.providers.set(new Sha256Provider());

    _this26.providers.set(new Sha384Provider());

    _this26.providers.set(new Sha512Provider());

    _this26.providers.set(new Pbkdf2Provider());

    _this26.providers.set(new HmacProvider());

    _this26.providers.set(new HkdfProvider());

    var nodeMajorVersion = (_a = /^v(\d+)/.exec(process.version)) === null || _a === void 0 ? void 0 : _a[1];

    if (nodeMajorVersion && parseInt(nodeMajorVersion, 10) >= 12) {
      _this26.providers.set(new Shake128Provider());

      _this26.providers.set(new Shake256Provider());
    }

    var hashes = crypto.getHashes();

    if (hashes.includes("sha3-256")) {
      _this26.providers.set(new Sha3256Provider());
    }

    if (hashes.includes("sha3-384")) {
      _this26.providers.set(new Sha3384Provider());
    }

    if (hashes.includes("sha3-512")) {
      _this26.providers.set(new Sha3512Provider());
    }

    if (nodeMajorVersion && parseInt(nodeMajorVersion, 10) >= 14) {
      _this26.providers.set(new EdDsaProvider());

      _this26.providers.set(new EcdhEsProvider());
    }

    return _this26;
  }

  return SubtleCrypto;
}(core.SubtleCrypto);

var Crypto = /*#__PURE__*/function (_core$Crypto) {
  _inherits(Crypto, _core$Crypto);

  var _super44 = _createSuper(Crypto);

  function Crypto() {
    var _this27;

    _classCallCheck(this, Crypto);

    _this27 = _super44.apply(this, arguments);
    _this27.subtle = new SubtleCrypto();
    return _this27;
  }

  _createClass(Crypto, [{
    key: "getRandomValues",
    value: function getRandomValues(array) {
      if (!ArrayBuffer.isView(array)) {
        throw new TypeError("Failed to execute 'getRandomValues' on 'Crypto': parameter 1 is not of type 'ArrayBufferView'");
      }

      var buffer = Buffer.from(array.buffer, array.byteOffset, array.byteLength);
      crypto__default.randomFillSync(buffer);
      return array;
    }
  }]);

  return Crypto;
}(core.Crypto);

export { Crypto };